//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthenticationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    externalLogin( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/external-login";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalLogin(_response);
        });
    }

    protected processExternalLogin(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getUserToken( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserToken(_response);
        });
    }

    protected processGetUserToken(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    externalLogout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/external-logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExternalLogout(_response);
        });
    }

    protected processExternalLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConsumerDomainsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getConsumerDomains(skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<ConsumerDomainsListResponseModel> {
        let url_ = this.baseUrl + "/api/consumer-domains?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConsumerDomains(_response);
        });
    }

    protected processGetConsumerDomains(response: AxiosResponse): Promise<ConsumerDomainsListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumerDomainsListResponseModel.fromJS(resultData200);
            return Promise.resolve<ConsumerDomainsListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumerDomainsListResponseModel>(null as any);
    }

    addConsumerDomain(model: ConsumerDomainPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/consumer-domains";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddConsumerDomain(_response);
        });
    }

    protected processAddConsumerDomain(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getConsumerDomain(domain: string | undefined, cancelToken?: CancelToken): Promise<ConsumerDomainResponseModel> {
        let url_ = this.baseUrl + "/api/consumer-domains/single?";
        if (domain === null)
            throw new globalThis.Error("The parameter 'domain' cannot be null.");
        else if (domain !== undefined)
            url_ += "domain=" + encodeURIComponent("" + domain) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConsumerDomain(_response);
        });
    }

    protected processGetConsumerDomain(response: AxiosResponse): Promise<ConsumerDomainResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConsumerDomainResponseModel.fromJS(resultData200);
            return Promise.resolve<ConsumerDomainResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConsumerDomainResponseModel>(null as any);
    }

    deleteDomain(domainName: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/consumer-domains/{domainName}";
        if (domainName === undefined || domainName === null)
            throw new globalThis.Error("The parameter 'domainName' must be defined.");
        url_ = url_.replace("{domainName}", encodeURIComponent("" + domainName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDomain(_response);
        });
    }

    protected processDeleteDomain(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DispatcherClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getUsage( cancelToken?: CancelToken): Promise<UserAgentsResponseModel[]> {
        let url_ = this.baseUrl + "/api/dispatcher/usage";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsage(_response);
        });
    }

    protected processGetUsage(response: AxiosResponse): Promise<UserAgentsResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAgentsResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UserAgentsResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAgentsResponseModel[]>(null as any);
    }
}

export class DwsimProClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getDwsimProUsage(model: GetDwsimProUsagePostModel, cancelToken?: CancelToken): Promise<DwsimProUsagePerUserModel> {
        let url_ = this.baseUrl + "/api/dwsim-pro/usage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDwsimProUsage(_response);
        });
    }

    protected processGetDwsimProUsage(response: AxiosResponse): Promise<DwsimProUsagePerUserModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DwsimProUsagePerUserModel.fromJS(resultData200);
            return Promise.resolve<DwsimProUsagePerUserModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwsimProUsagePerUserModel>(null as any);
    }

    getDwsimProLicenses(hideTestUsers: boolean | undefined, hideConsumers: boolean | undefined, organizationType: OrganizationType | null | undefined, hasAccessedDwsimPro: boolean | null | undefined, dateFrom: Date | null | undefined, isPaid: boolean | null | undefined, dateTo: Date | null | undefined, orderBy: string | null | undefined, isDescending: boolean | undefined, showOnlyActive: boolean | null | undefined, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<UsageListResultOfDwsimProLicenseModel> {
        let url_ = this.baseUrl + "/api/dwsim-pro/licenses?";
        if (hideTestUsers === null)
            throw new globalThis.Error("The parameter 'hideTestUsers' cannot be null.");
        else if (hideTestUsers !== undefined)
            url_ += "HideTestUsers=" + encodeURIComponent("" + hideTestUsers) + "&";
        if (hideConsumers === null)
            throw new globalThis.Error("The parameter 'hideConsumers' cannot be null.");
        else if (hideConsumers !== undefined)
            url_ += "HideConsumers=" + encodeURIComponent("" + hideConsumers) + "&";
        if (organizationType !== undefined && organizationType !== null)
            url_ += "OrganizationType=" + encodeURIComponent("" + organizationType) + "&";
        if (hasAccessedDwsimPro !== undefined && hasAccessedDwsimPro !== null)
            url_ += "HasAccessedDwsimPro=" + encodeURIComponent("" + hasAccessedDwsimPro) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (isPaid !== undefined && isPaid !== null)
            url_ += "IsPaid=" + encodeURIComponent("" + isPaid) + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (isDescending === null)
            throw new globalThis.Error("The parameter 'isDescending' cannot be null.");
        else if (isDescending !== undefined)
            url_ += "IsDescending=" + encodeURIComponent("" + isDescending) + "&";
        if (showOnlyActive !== undefined && showOnlyActive !== null)
            url_ += "ShowOnlyActive=" + encodeURIComponent("" + showOnlyActive) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDwsimProLicenses(_response);
        });
    }

    protected processGetDwsimProLicenses(response: AxiosResponse): Promise<UsageListResultOfDwsimProLicenseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UsageListResultOfDwsimProLicenseModel.fromJS(resultData200);
            return Promise.resolve<UsageListResultOfDwsimProLicenseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UsageListResultOfDwsimProLicenseModel>(null as any);
    }

    getDwsimProUserLicenseStatus(userName: string, cancelToken?: CancelToken): Promise<DwsimProUserLicenseResponseModel> {
        let url_ = this.baseUrl + "/api/dwsim-pro/{userName}/license-status";
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDwsimProUserLicenseStatus(_response);
        });
    }

    protected processGetDwsimProUserLicenseStatus(response: AxiosResponse): Promise<DwsimProUserLicenseResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DwsimProUserLicenseResponseModel.fromJS(resultData200);
            return Promise.resolve<DwsimProUserLicenseResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwsimProUserLicenseResponseModel>(null as any);
    }

    getDomainMotherTicketInfo(model: DomainMotherTicketPostModel, cancelToken?: CancelToken): Promise<DomainMotherTicketResponseModel> {
        let url_ = this.baseUrl + "/api/dwsim-pro/domain-mother-ticket-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDomainMotherTicketInfo(_response);
        });
    }

    protected processGetDomainMotherTicketInfo(response: AxiosResponse): Promise<DomainMotherTicketResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DomainMotherTicketResponseModel.fromJS(resultData200);
            return Promise.resolve<DomainMotherTicketResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DomainMotherTicketResponseModel>(null as any);
    }

    syncUserActivitiesFromGraylog( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/dwsim-pro/sync-screenshots-from-graylog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncUserActivitiesFromGraylog(_response);
        });
    }

    protected processSyncUserActivitiesFromGraylog(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class GroupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getGroups( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class HostsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getHosts( cancelToken?: CancelToken): Promise<HostPoolResultModel[]> {
        let url_ = this.baseUrl + "/api/hosts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHosts(_response);
        });
    }

    protected processGetHosts(response: AxiosResponse): Promise<HostPoolResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HostPoolResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HostPoolResultModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HostPoolResultModel[]>(null as any);
    }

    getSessionHosts(resourceGroupName: string, hostPoolName: string, cancelToken?: CancelToken): Promise<SessionHostModel[]> {
        let url_ = this.baseUrl + "/api/hosts/session-hosts/{resourceGroupName}/{hostPoolName}";
        if (resourceGroupName === undefined || resourceGroupName === null)
            throw new globalThis.Error("The parameter 'resourceGroupName' must be defined.");
        url_ = url_.replace("{resourceGroupName}", encodeURIComponent("" + resourceGroupName));
        if (hostPoolName === undefined || hostPoolName === null)
            throw new globalThis.Error("The parameter 'hostPoolName' must be defined.");
        url_ = url_.replace("{hostPoolName}", encodeURIComponent("" + hostPoolName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessionHosts(_response);
        });
    }

    protected processGetSessionHosts(response: AxiosResponse): Promise<SessionHostModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SessionHostModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<SessionHostModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionHostModel[]>(null as any);
    }

    sendNotifications(model: NotificationPostModel, resourceGroupName: string, hostPoolName: string, cancelToken?: CancelToken): Promise<NotificationResultModel> {
        let url_ = this.baseUrl + "/api/hosts/session-hosts/{resourceGroupName}/{hostPoolName}/send-notifications";
        if (resourceGroupName === undefined || resourceGroupName === null)
            throw new globalThis.Error("The parameter 'resourceGroupName' must be defined.");
        url_ = url_.replace("{resourceGroupName}", encodeURIComponent("" + resourceGroupName));
        if (hostPoolName === undefined || hostPoolName === null)
            throw new globalThis.Error("The parameter 'hostPoolName' must be defined.");
        url_ = url_.replace("{hostPoolName}", encodeURIComponent("" + hostPoolName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendNotifications(_response);
        });
    }

    protected processSendNotifications(response: AxiosResponse): Promise<NotificationResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationResultModel.fromJS(resultData200);
            return Promise.resolve<NotificationResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationResultModel>(null as any);
    }

    logoutUser(resourceGroupName: string, hostPoolName: string, sessionHostName: string, userSessionName: string, cancelToken?: CancelToken): Promise<NotificationResultModel> {
        let url_ = this.baseUrl + "/api/hosts/session-hosts/{resourceGroupName}/{hostPoolName}/{sessionHostName}/{userSessionName}";
        if (resourceGroupName === undefined || resourceGroupName === null)
            throw new globalThis.Error("The parameter 'resourceGroupName' must be defined.");
        url_ = url_.replace("{resourceGroupName}", encodeURIComponent("" + resourceGroupName));
        if (hostPoolName === undefined || hostPoolName === null)
            throw new globalThis.Error("The parameter 'hostPoolName' must be defined.");
        url_ = url_.replace("{hostPoolName}", encodeURIComponent("" + hostPoolName));
        if (sessionHostName === undefined || sessionHostName === null)
            throw new globalThis.Error("The parameter 'sessionHostName' must be defined.");
        url_ = url_.replace("{sessionHostName}", encodeURIComponent("" + sessionHostName));
        if (userSessionName === undefined || userSessionName === null)
            throw new globalThis.Error("The parameter 'userSessionName' must be defined.");
        url_ = url_.replace("{userSessionName}", encodeURIComponent("" + userSessionName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogoutUser(_response);
        });
    }

    protected processLogoutUser(response: AxiosResponse): Promise<NotificationResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NotificationResultModel.fromJS(resultData200);
            return Promise.resolve<NotificationResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationResultModel>(null as any);
    }
}

export class MotherTicketClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getMotherTickets(name: string | undefined, showHidden: boolean | undefined, createdFromDate: Date | null | undefined, createdToDate: Date | null | undefined, includeTags: number[] | null | undefined, includeTagsOperator: LogicalOperator | null | undefined, excludeTags: number[] | null | undefined, excludeTagsOperator: LogicalOperator | null | undefined, orderBy: string | null | undefined, orderByDescending: boolean | undefined, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<ListResultOfMotherTicketForListResponseModel> {
        let url_ = this.baseUrl + "/api/mother-ticket?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (showHidden === null)
            throw new globalThis.Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "ShowHidden=" + encodeURIComponent("" + showHidden) + "&";
        if (createdFromDate !== undefined && createdFromDate !== null)
            url_ += "CreatedFromDate=" + encodeURIComponent(createdFromDate ? "" + createdFromDate.toISOString() : "") + "&";
        if (createdToDate !== undefined && createdToDate !== null)
            url_ += "CreatedToDate=" + encodeURIComponent(createdToDate ? "" + createdToDate.toISOString() : "") + "&";
        if (includeTags !== undefined && includeTags !== null)
            includeTags && includeTags.forEach(item => { url_ += "IncludeTags=" + encodeURIComponent("" + item) + "&"; });
        if (includeTagsOperator !== undefined && includeTagsOperator !== null)
            url_ += "IncludeTagsOperator=" + encodeURIComponent("" + includeTagsOperator) + "&";
        if (excludeTags !== undefined && excludeTags !== null)
            excludeTags && excludeTags.forEach(item => { url_ += "ExcludeTags=" + encodeURIComponent("" + item) + "&"; });
        if (excludeTagsOperator !== undefined && excludeTagsOperator !== null)
            url_ += "ExcludeTagsOperator=" + encodeURIComponent("" + excludeTagsOperator) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDescending === null)
            throw new globalThis.Error("The parameter 'orderByDescending' cannot be null.");
        else if (orderByDescending !== undefined)
            url_ += "OrderByDescending=" + encodeURIComponent("" + orderByDescending) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMotherTickets(_response);
        });
    }

    protected processGetMotherTickets(response: AxiosResponse): Promise<ListResultOfMotherTicketForListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultOfMotherTicketForListResponseModel.fromJS(resultData200);
            return Promise.resolve<ListResultOfMotherTicketForListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultOfMotherTicketForListResponseModel>(null as any);
    }

    getUserMotherTicket(userId: string, cancelToken?: CancelToken): Promise<MotherTicketForListResponseModel> {
        let url_ = this.baseUrl + "/api/mother-ticket/user-mother-ticket/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserMotherTicket(_response);
        });
    }

    protected processGetUserMotherTicket(response: AxiosResponse): Promise<MotherTicketForListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MotherTicketForListResponseModel.fromJS(resultData200);
            return Promise.resolve<MotherTicketForListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotherTicketForListResponseModel>(null as any);
    }

    hideMotherTicket(motherTicketId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mother-ticket/{motherTicketId}/hide";
        if (motherTicketId === undefined || motherTicketId === null)
            throw new globalThis.Error("The parameter 'motherTicketId' must be defined.");
        url_ = url_.replace("{motherTicketId}", encodeURIComponent("" + motherTicketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHideMotherTicket(_response);
        });
    }

    protected processHideMotherTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeHideFromMotherTicket(motherTicketId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mother-ticket/{motherTicketId}/remove-hide";
        if (motherTicketId === undefined || motherTicketId === null)
            throw new globalThis.Error("The parameter 'motherTicketId' must be defined.");
        url_ = url_.replace("{motherTicketId}", encodeURIComponent("" + motherTicketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveHideFromMotherTicket(_response);
        });
    }

    protected processRemoveHideFromMotherTicket(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createMotherTicket(model: MotherTicketPostModel, cancelToken?: CancelToken): Promise<CreateMotherTicketResponseModel> {
        let url_ = this.baseUrl + "/api/mother-ticket/create-ticket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMotherTicket(_response);
        });
    }

    protected processCreateMotherTicket(response: AxiosResponse): Promise<CreateMotherTicketResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateMotherTicketResponseModel.fromJS(resultData200);
            return Promise.resolve<CreateMotherTicketResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateMotherTicketResponseModel>(null as any);
    }

    motherTicketCreatedOrUpdatedEvent(model: MotherTicketCreatedOrUpdatedEventModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mother-ticket/update-mailchimp-tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMotherTicketCreatedOrUpdatedEvent(_response);
        });
    }

    protected processMotherTicketCreatedOrUpdatedEvent(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDuplicatedDomains( cancelToken?: CancelToken): Promise<DuplicateMotherTicketDomainResponseModel[]> {
        let url_ = this.baseUrl + "/api/mother-ticket/duplicated-domains";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDuplicatedDomains(_response);
        });
    }

    protected processGetDuplicatedDomains(response: AxiosResponse): Promise<DuplicateMotherTicketDomainResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DuplicateMotherTicketDomainResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DuplicateMotherTicketDomainResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DuplicateMotherTicketDomainResponseModel[]>(null as any);
    }

    reindexMailchimpTags( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mother-ticket/reindex-mailchimp-tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReindexMailchimpTags(_response);
        });
    }

    protected processReindexMailchimpTags(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    addMissingCommentsForRegisteredUsers( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mother-ticket/registered-users/add-missing-comments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMissingCommentsForRegisteredUsers(_response);
        });
    }

    protected processAddMissingCommentsForRegisteredUsers(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    addUniversityTag(motherTicketId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mother-ticket/{motherTicketId}/add-university-tag";
        if (motherTicketId === undefined || motherTicketId === null)
            throw new globalThis.Error("The parameter 'motherTicketId' must be defined.");
        url_ = url_.replace("{motherTicketId}", encodeURIComponent("" + motherTicketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUniversityTag(_response);
        });
    }

    protected processAddUniversityTag(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class MotherTicketSyncClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    syncAllMotherTickets( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mother-ticket-sync/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncAllMotherTickets(_response);
        });
    }

    protected processSyncAllMotherTickets(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSyncStatus( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/mother-ticket-sync/all/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSyncStatus(_response);
        });
    }

    protected processGetSyncStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class MotherTicketTagsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getTags( cancelToken?: CancelToken): Promise<MotherTicketTagResponseModel[]> {
        let url_ = this.baseUrl + "/api/mother-ticket-tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTags(_response);
        });
    }

    protected processGetTags(response: AxiosResponse): Promise<MotherTicketTagResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MotherTicketTagResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MotherTicketTagResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MotherTicketTagResponseModel[]>(null as any);
    }
}

export class MSAnalyticsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getAnalytics(hideTestUsers: boolean | undefined, cancelToken?: CancelToken): Promise<DwsimProUserAnalyticsResponseModel[]> {
        let url_ = this.baseUrl + "/api/ms-analytics?";
        if (hideTestUsers === null)
            throw new globalThis.Error("The parameter 'hideTestUsers' cannot be null.");
        else if (hideTestUsers !== undefined)
            url_ += "hideTestUsers=" + encodeURIComponent("" + hideTestUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnalytics(_response);
        });
    }

    protected processGetAnalytics(response: AxiosResponse): Promise<DwsimProUserAnalyticsResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DwsimProUserAnalyticsResponseModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DwsimProUserAnalyticsResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DwsimProUserAnalyticsResponseModel[]>(null as any);
    }
}

export class OrganizationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    updateOrganizationUsers( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/organizations/update-org-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrganizationUsers(_response);
        });
    }

    protected processUpdateOrganizationUsers(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSyncUsersStatus( cancelToken?: CancelToken): Promise<SyncUsersStatusResponseModel> {
        let url_ = this.baseUrl + "/api/organizations/get-sync-users-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSyncUsersStatus(_response);
        });
    }

    protected processGetSyncUsersStatus(response: AxiosResponse): Promise<SyncUsersStatusResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SyncUsersStatusResponseModel.fromJS(resultData200);
            return Promise.resolve<SyncUsersStatusResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SyncUsersStatusResponseModel>(null as any);
    }
}

export class PricingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getPriceCheckLogs(username: string | null | undefined, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<UserPriceCheckLogsListResponseModel> {
        let url_ = this.baseUrl + "/api/pricing/log-get-price?";
        if (username !== undefined && username !== null)
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPriceCheckLogs(_response);
        });
    }

    protected processGetPriceCheckLogs(response: AxiosResponse): Promise<UserPriceCheckLogsListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserPriceCheckLogsListResponseModel.fromJS(resultData200);
            return Promise.resolve<UserPriceCheckLogsListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserPriceCheckLogsListResponseModel>(null as any);
    }

    logGetPrice(model: GetPriceTrackPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/pricing/log-get-price";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogGetPrice(_response);
        });
    }

    protected processLogGetPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class QuestionaresClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    submitAnswers(model: SubmitAnswersPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/questionaires";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitAnswers(_response);
        });
    }

    protected processSubmitAnswers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getLoginQuestionareAnswers(username: string | undefined, signupReason: string | undefined, howYouWorkOnFlowsheets: string | undefined, usedDwsimFree: string | undefined, dwsimRate: number | null | undefined, protectProperty: string | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, includeUserTags: number[] | null | undefined, includeOperator: LogicalOperator | null | undefined, excludeUserTags: number[] | null | undefined, excludeOperator: LogicalOperator | null | undefined, orderBy: string | null | undefined, orderByDescending: boolean | undefined, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<ListResultOfQuestionaireResponseModel> {
        let url_ = this.baseUrl + "/api/questionaires/login?";
        if (username === null)
            throw new globalThis.Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        if (signupReason === null)
            throw new globalThis.Error("The parameter 'signupReason' cannot be null.");
        else if (signupReason !== undefined)
            url_ += "SignupReason=" + encodeURIComponent("" + signupReason) + "&";
        if (howYouWorkOnFlowsheets === null)
            throw new globalThis.Error("The parameter 'howYouWorkOnFlowsheets' cannot be null.");
        else if (howYouWorkOnFlowsheets !== undefined)
            url_ += "HowYouWorkOnFlowsheets=" + encodeURIComponent("" + howYouWorkOnFlowsheets) + "&";
        if (usedDwsimFree === null)
            throw new globalThis.Error("The parameter 'usedDwsimFree' cannot be null.");
        else if (usedDwsimFree !== undefined)
            url_ += "UsedDwsimFree=" + encodeURIComponent("" + usedDwsimFree) + "&";
        if (dwsimRate !== undefined && dwsimRate !== null)
            url_ += "DwsimRate=" + encodeURIComponent("" + dwsimRate) + "&";
        if (protectProperty === null)
            throw new globalThis.Error("The parameter 'protectProperty' cannot be null.");
        else if (protectProperty !== undefined)
            url_ += "ProtectProperty=" + encodeURIComponent("" + protectProperty) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (includeUserTags !== undefined && includeUserTags !== null)
            includeUserTags && includeUserTags.forEach(item => { url_ += "IncludeUserTags=" + encodeURIComponent("" + item) + "&"; });
        if (includeOperator !== undefined && includeOperator !== null)
            url_ += "IncludeOperator=" + encodeURIComponent("" + includeOperator) + "&";
        if (excludeUserTags !== undefined && excludeUserTags !== null)
            excludeUserTags && excludeUserTags.forEach(item => { url_ += "ExcludeUserTags=" + encodeURIComponent("" + item) + "&"; });
        if (excludeOperator !== undefined && excludeOperator !== null)
            url_ += "ExcludeOperator=" + encodeURIComponent("" + excludeOperator) + "&";
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDescending === null)
            throw new globalThis.Error("The parameter 'orderByDescending' cannot be null.");
        else if (orderByDescending !== undefined)
            url_ += "OrderByDescending=" + encodeURIComponent("" + orderByDescending) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoginQuestionareAnswers(_response);
        });
    }

    protected processGetLoginQuestionareAnswers(response: AxiosResponse): Promise<ListResultOfQuestionaireResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultOfQuestionaireResponseModel.fromJS(resultData200);
            return Promise.resolve<ListResultOfQuestionaireResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultOfQuestionaireResponseModel>(null as any);
    }
}

export class TestUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getTestUsers(skip: number | null | undefined, take: number | null | undefined, applyPagination: boolean | undefined, cancelToken?: CancelToken): Promise<TestUsersListResponseModel> {
        let url_ = this.baseUrl + "/api/test-users?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (applyPagination === null)
            throw new globalThis.Error("The parameter 'applyPagination' cannot be null.");
        else if (applyPagination !== undefined)
            url_ += "applyPagination=" + encodeURIComponent("" + applyPagination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTestUsers(_response);
        });
    }

    protected processGetTestUsers(response: AxiosResponse): Promise<TestUsersListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TestUsersListResponseModel.fromJS(resultData200);
            return Promise.resolve<TestUsersListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TestUsersListResponseModel>(null as any);
    }

    addTestUser(model: TestUserPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/test-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTestUser(_response);
        });
    }

    protected processAddTestUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTestUser(userId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/test-users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTestUser(_response);
        });
    }

    protected processDeleteTestUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getCurrentUser( cancelToken?: CancelToken): Promise<UserLoginResponseModel> {
        let url_ = this.baseUrl + "/api/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<UserLoginResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserLoginResponseModel.fromJS(resultData200);
            return Promise.resolve<UserLoginResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserLoginResponseModel>(null as any);
    }

    blockUnblockUser(model: BlockUserPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/users/block-unblock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBlockUnblockUser(_response);
        });
    }

    protected processBlockUnblockUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getLinkedInUrl(userId: string, cancelToken?: CancelToken): Promise<EnrichlayerLinkedInResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}/linkedin-url";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLinkedInUrl(_response);
        });
    }

    protected processGetLinkedInUrl(response: AxiosResponse): Promise<EnrichlayerLinkedInResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EnrichlayerLinkedInResponse.fromJS(resultData200);
            return Promise.resolve<EnrichlayerLinkedInResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnrichlayerLinkedInResponse>(null as any);
    }

    getEmailCategory(model: EmailCategoryPostModel, cancelToken?: CancelToken): Promise<EmailCategoryResponseModel> {
        let url_ = this.baseUrl + "/api/users/get-email-category";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailCategory(_response);
        });
    }

    protected processGetEmailCategory(response: AxiosResponse): Promise<EmailCategoryResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailCategoryResponseModel.fromJS(resultData200);
            return Promise.resolve<EmailCategoryResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailCategoryResponseModel>(null as any);
    }

    updateIsConsumerFlags( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/users/update-users-is-consumer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIsConsumerFlags(_response);
        });
    }

    protected processUpdateIsConsumerFlags(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getUserDetails(userId: string, cancelToken?: CancelToken): Promise<UserResultModel> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserDetails(_response);
        });
    }

    protected processGetUserDetails(response: AxiosResponse): Promise<UserResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserResultModel.fromJS(resultData200);
            return Promise.resolve<UserResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResultModel>(null as any);
    }

    deleteUser(userId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUserBusinessDetails(userId: string, cancelToken?: CancelToken): Promise<UserBusinessResponseModel> {
        let url_ = this.baseUrl + "/api/users/{userId}/business-details";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserBusinessDetails(_response);
        });
    }

    protected processGetUserBusinessDetails(response: AxiosResponse): Promise<UserBusinessResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserBusinessResponseModel.fromJS(resultData200);
            return Promise.resolve<UserBusinessResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserBusinessResponseModel>(null as any);
    }

    getUserSlimDetails(userId: string, cancelToken?: CancelToken): Promise<UserSlimModel> {
        let url_ = this.baseUrl + "/api/users/{userId}/slim";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserSlimDetails(_response);
        });
    }

    protected processGetUserSlimDetails(response: AxiosResponse): Promise<UserSlimModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserSlimModel.fromJS(resultData200);
            return Promise.resolve<UserSlimModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserSlimModel>(null as any);
    }

    getCachedUsers(skip: number | null | undefined, take: number | null | undefined, includeUserTags: number[] | null | undefined, includeOperator: LogicalOperator | null | undefined, excludeUserTags: number[] | null | undefined, excludeOperator: LogicalOperator | null | undefined, createdFromDate: Date | null | undefined, createdToDate: Date | null | undefined, searchTerm: string | undefined, motherTicketId: number | null | undefined, showActivityLevels: UserActivityLevel[] | undefined, orderBy: string | null | undefined, orderByDescending: boolean | undefined, cancelToken?: CancelToken): Promise<ListResultOfUserResultModel> {
        let url_ = this.baseUrl + "/api/users/cached?";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (includeUserTags !== undefined && includeUserTags !== null)
            includeUserTags && includeUserTags.forEach(item => { url_ += "IncludeUserTags=" + encodeURIComponent("" + item) + "&"; });
        if (includeOperator !== undefined && includeOperator !== null)
            url_ += "IncludeOperator=" + encodeURIComponent("" + includeOperator) + "&";
        if (excludeUserTags !== undefined && excludeUserTags !== null)
            excludeUserTags && excludeUserTags.forEach(item => { url_ += "ExcludeUserTags=" + encodeURIComponent("" + item) + "&"; });
        if (excludeOperator !== undefined && excludeOperator !== null)
            url_ += "ExcludeOperator=" + encodeURIComponent("" + excludeOperator) + "&";
        if (createdFromDate !== undefined && createdFromDate !== null)
            url_ += "CreatedFromDate=" + encodeURIComponent(createdFromDate ? "" + createdFromDate.toISOString() : "") + "&";
        if (createdToDate !== undefined && createdToDate !== null)
            url_ += "CreatedToDate=" + encodeURIComponent(createdToDate ? "" + createdToDate.toISOString() : "") + "&";
        if (searchTerm === null)
            throw new globalThis.Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (motherTicketId !== undefined && motherTicketId !== null)
            url_ += "MotherTicketId=" + encodeURIComponent("" + motherTicketId) + "&";
        if (showActivityLevels === null)
            throw new globalThis.Error("The parameter 'showActivityLevels' cannot be null.");
        else if (showActivityLevels !== undefined)
            showActivityLevels && showActivityLevels.forEach(item => { url_ += "ShowActivityLevels=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDescending === null)
            throw new globalThis.Error("The parameter 'orderByDescending' cannot be null.");
        else if (orderByDescending !== undefined)
            url_ += "OrderByDescending=" + encodeURIComponent("" + orderByDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCachedUsers(_response);
        });
    }

    protected processGetCachedUsers(response: AxiosResponse): Promise<ListResultOfUserResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultOfUserResultModel.fromJS(resultData200);
            return Promise.resolve<ListResultOfUserResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultOfUserResultModel>(null as any);
    }
}

export class UserSyncClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    syncAllUsers( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user-sync/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncAllUsers(_response);
        });
    }

    protected processSyncAllUsers(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSyncStatus( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user-sync/all/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSyncStatus(_response);
        });
    }

    protected processGetSyncStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    syncSingleUser(userId: string, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user-sync/sync-single/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncSingleUser(_response);
        });
    }

    protected processSyncSingleUser(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    syncEmailConfirmations( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/user-sync/sync-email-confirmations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncEmailConfirmations(_response);
        });
    }

    protected processSyncEmailConfirmations(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class UserTagsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getUserTags(excludeChildren: boolean | null | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<ListResultOfUserTagResponseModel> {
        let url_ = this.baseUrl + "/api/user-tags?";
        if (excludeChildren !== undefined && excludeChildren !== null)
            url_ += "ExcludeChildren=" + encodeURIComponent("" + excludeChildren) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserTags(_response);
        });
    }

    protected processGetUserTags(response: AxiosResponse): Promise<ListResultOfUserTagResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResultOfUserTagResponseModel.fromJS(resultData200);
            return Promise.resolve<ListResultOfUserTagResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResultOfUserTagResponseModel>(null as any);
    }

    createTag(model: CreateUserTagPostModel, cancelToken?: CancelToken): Promise<UserTagResponseModel> {
        let url_ = this.baseUrl + "/api/user-tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTag(_response);
        });
    }

    protected processCreateTag(response: AxiosResponse): Promise<UserTagResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserTagResponseModel.fromJS(resultData200);
            return Promise.resolve<UserTagResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserTagResponseModel>(null as any);
    }

    addOrUpdateReadyToOrderTag(model: ReadyToOrderPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user-tags/ready-to-order";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateReadyToOrderTag(_response);
        });
    }

    protected processAddOrUpdateReadyToOrderTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUserUserTags(userId: string, cancelToken?: CancelToken): Promise<UsersTagsListResponseModel> {
        let url_ = this.baseUrl + "/api/user-tags/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserUserTags(_response);
        });
    }

    protected processGetUserUserTags(response: AxiosResponse): Promise<UsersTagsListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UsersTagsListResponseModel.fromJS(resultData200);
            return Promise.resolve<UsersTagsListResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UsersTagsListResponseModel>(null as any);
    }

    addUsersTag(model: AddUsersTagPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user-tags/add-users-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUsersTag(_response);
        });
    }

    protected processAddUsersTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeUsersTag(model: RemoveUsersTagPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user-tags/remove-users-tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUsersTag(_response);
        });
    }

    protected processRemoveUsersTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteUserTag(tagId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user-tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new globalThis.Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserTag(_response);
        });
    }

    protected processDeleteUserTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserTrackingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    logUserAction(model: LogUserActionPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/user-tracking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogUserAction(_response);
        });
    }

    protected processLogUserAction(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WebinarsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getWebinar(webinarId: number, cancelToken?: CancelToken): Promise<WebinarResponseModel> {
        let url_ = this.baseUrl + "/api/webinars/{webinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new globalThis.Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWebinar(_response);
        });
    }

    protected processGetWebinar(response: AxiosResponse): Promise<WebinarResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WebinarResponseModel.fromJS(resultData200);
            return Promise.resolve<WebinarResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebinarResponseModel>(null as any);
    }

    updateWebinar(webinarId: number, model: EditWebinarPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/webinars/{webinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new globalThis.Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWebinar(_response);
        });
    }

    protected processUpdateWebinar(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    syncWebinarsFromZoom( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/webinars/sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncWebinarsFromZoom(_response);
        });
    }

    protected processSyncWebinarsFromZoom(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getWebinars(name: string | undefined, sortBy: string | null | undefined, sortDescending: boolean | undefined, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfWebinarForListResponseModel> {
        let url_ = this.baseUrl + "/api/webinars?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWebinars(_response);
        });
    }

    protected processGetWebinars(response: AxiosResponse): Promise<PagedListOfWebinarForListResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedListOfWebinarForListResponseModel.fromJS(resultData200);
            return Promise.resolve<PagedListOfWebinarForListResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfWebinarForListResponseModel>(null as any);
    }
}

export class WebinarsSyncClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    resyncWebinar(webinarId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/webinars-sync/{webinarId}/resync";
        if (webinarId === undefined || webinarId === null)
            throw new globalThis.Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResyncWebinar(_response);
        });
    }

    protected processResyncWebinar(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    syncAllWebinars( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/webinars-sync/resync-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncAllWebinars(_response);
        });
    }

    protected processSyncAllWebinars(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    syncWebinar(webinarId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/webinars-sync/single/{webinarId}";
        if (webinarId === undefined || webinarId === null)
            throw new globalThis.Error("The parameter 'webinarId' must be defined.");
        url_ = url_.replace("{webinarId}", encodeURIComponent("" + webinarId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncWebinar(_response);
        });
    }

    protected processSyncWebinar(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSyncStatus( cancelToken?: CancelToken): Promise<SyncWebinarsRunningModel> {
        let url_ = this.baseUrl + "/api/webinars-sync/all/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSyncStatus(_response);
        });
    }

    protected processGetSyncStatus(response: AxiosResponse): Promise<SyncWebinarsRunningModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SyncWebinarsRunningModel.fromJS(resultData200);
            return Promise.resolve<SyncWebinarsRunningModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SyncWebinarsRunningModel>(null as any);
    }
}

export class ZoomIntegrationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    updateUserMeetingRegistrants(model: EventModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/zoom-integrations/update-registrants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserMeetingRegistrants(_response);
        });
    }

    protected processUpdateUserMeetingRegistrants(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserPrinicipalNameClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getUserPrincipalName(request: UserPrincipalNameRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/external/user-principal-name/get-user-principal-name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPrincipalName(_response);
        });
    }

    protected processGetUserPrincipalName(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ContactSupportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    contactSupport(subject: string | undefined, message: string | undefined, file: FileParameter | null | undefined, messageType: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/dwsim-pro/contact-support";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (subject === null || subject === undefined)
            throw new globalThis.Error("The parameter 'subject' cannot be null.");
        else
            content_.append("Subject", subject.toString());
        if (message === null || message === undefined)
            throw new globalThis.Error("The parameter 'message' cannot be null.");
        else
            content_.append("Message", message.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (messageType !== null && messageType !== undefined)
            content_.append("MessageType", messageType.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactSupport(_response);
        });
    }

    protected processContactSupport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EmailConfirmationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    submitBusinessEmail(model: SubmitBusinessEmailPostModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/email-confirmations/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitBusinessEmail(_response);
        });
    }

    protected processSubmitBusinessEmail(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    emailConfirmed(model: EmailConfirmedPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/email-confirmations/confirmed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailConfirmed(_response);
        });
    }

    protected processEmailConfirmed(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getTestConfirmationToken(model: CreateEmailConfirmationTokenModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/email-confirmations/get-test-confirmationToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTestConfirmationToken(_response);
        });
    }

    protected processGetTestConfirmationToken(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    resendConfirmationMail( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/email-confirmations/resend-confirmation-mail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendConfirmationMail(_response);
        });
    }

    protected processResendConfirmationMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getBusinessEmailConfirmationStatus( cancelToken?: CancelToken): Promise<BusinessEmailConfirmationStatusResponseModel> {
        let url_ = this.baseUrl + "/api/email-confirmations/confirmation-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBusinessEmailConfirmationStatus(_response);
        });
    }

    protected processGetBusinessEmailConfirmationStatus(response: AxiosResponse): Promise<BusinessEmailConfirmationStatusResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BusinessEmailConfirmationStatusResponseModel.fromJS(resultData200);
            return Promise.resolve<BusinessEmailConfirmationStatusResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BusinessEmailConfirmationStatusResponseModel>(null as any);
    }
}

export class FeedbacksClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    submitFeedback(model: FeedbackPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/feedbacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitFeedback(_response);
        });
    }

    protected processSubmitFeedback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getFeedbacks(username: string | undefined, userType: UserType | null | undefined, npsCategory: NpsCategory | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, includeUserTags: number[] | null | undefined, includeOperator: LogicalOperator | null | undefined, excludeUserTags: number[] | null | undefined, excludeOperator: LogicalOperator | null | undefined, skip: number | null | undefined, take: number | null | undefined, cancelToken?: CancelToken): Promise<FeedbacksResultModel> {
        let url_ = this.baseUrl + "/api/feedbacks?";
        if (username === null)
            throw new globalThis.Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        if (userType !== undefined && userType !== null)
            url_ += "UserType=" + encodeURIComponent("" + userType) + "&";
        if (npsCategory !== undefined && npsCategory !== null)
            url_ += "NpsCategory=" + encodeURIComponent("" + npsCategory) + "&";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo !== undefined && dateTo !== null)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (includeUserTags !== undefined && includeUserTags !== null)
            includeUserTags && includeUserTags.forEach(item => { url_ += "IncludeUserTags=" + encodeURIComponent("" + item) + "&"; });
        if (includeOperator !== undefined && includeOperator !== null)
            url_ += "IncludeOperator=" + encodeURIComponent("" + includeOperator) + "&";
        if (excludeUserTags !== undefined && excludeUserTags !== null)
            excludeUserTags && excludeUserTags.forEach(item => { url_ += "ExcludeUserTags=" + encodeURIComponent("" + item) + "&"; });
        if (excludeOperator !== undefined && excludeOperator !== null)
            url_ += "ExcludeOperator=" + encodeURIComponent("" + excludeOperator) + "&";
        if (skip !== undefined && skip !== null)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFeedbacks(_response);
        });
    }

    protected processGetFeedbacks(response: AxiosResponse): Promise<FeedbacksResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeedbacksResultModel.fromJS(resultData200);
            return Promise.resolve<FeedbacksResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeedbacksResultModel>(null as any);
    }

    updateUserIdsOnFeedbacks( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/feedbacks/update-user-ids";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserIdsOnFeedbacks(_response);
        });
    }

    protected processUpdateUserIdsOnFeedbacks(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getLatestFeedback(username: string, cancelToken?: CancelToken): Promise<FeedbackResponseModel> {
        let url_ = this.baseUrl + "/api/feedbacks/latest/{username}";
        if (username === undefined || username === null)
            throw new globalThis.Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestFeedback(_response);
        });
    }

    protected processGetLatestFeedback(response: AxiosResponse): Promise<FeedbackResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FeedbackResponseModel.fromJS(resultData200);
            return Promise.resolve<FeedbackResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeedbackResponseModel>(null as any);
    }
}

export class ExportScreenshotsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    submitGenerateZipRequest(model: DownloadScreenshotsRequestModel, cancelToken?: CancelToken): Promise<DownloadScreenshotsResponseModel> {
        let url_ = this.baseUrl + "/api/screenshots/submit-generate-zip-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmitGenerateZipRequest(_response);
        });
    }

    protected processSubmitGenerateZipRequest(response: AxiosResponse): Promise<DownloadScreenshotsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DownloadScreenshotsResponseModel.fromJS(resultData200);
            return Promise.resolve<DownloadScreenshotsResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DownloadScreenshotsResponseModel>(null as any);
    }

    getGenerateZipRequestStatus(requestId: string, cancelToken?: CancelToken): Promise<GenerateScreenshotsZipStatusResponse> {
        let url_ = this.baseUrl + "/api/screenshots/generate-zip-request-status/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new globalThis.Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGenerateZipRequestStatus(_response);
        });
    }

    protected processGetGenerateZipRequestStatus(response: AxiosResponse): Promise<GenerateScreenshotsZipStatusResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GenerateScreenshotsZipStatusResponse.fromJS(resultData200);
            return Promise.resolve<GenerateScreenshotsZipStatusResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GenerateScreenshotsZipStatusResponse>(null as any);
    }

    downloadScreenshots(requestId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/screenshots/download/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new globalThis.Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadScreenshots(_response);
        });
    }

    protected processDownloadScreenshots(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResultModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ScreenshotsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getScreenShots(query: ScreenshotsQuery, cancelToken?: CancelToken): Promise<ScreenshotMessageResultModel> {
        let url_ = this.baseUrl + "/api/screenshots";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScreenShots(_response);
        });
    }

    protected processGetScreenShots(response: AxiosResponse): Promise<ScreenshotMessageResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScreenshotMessageResultModel.fromJS(resultData200);
            return Promise.resolve<ScreenshotMessageResultModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScreenshotMessageResultModel>(null as any);
    }

    getScreenshotImage(screenshotId: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/screenshots/{screenshotId}";
        if (screenshotId === undefined || screenshotId === null)
            throw new globalThis.Error("The parameter 'screenshotId' must be defined.");
        url_ = url_.replace("{screenshotId}", encodeURIComponent("" + screenshotId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScreenshotImage(_response);
        });
    }

    protected processGetScreenshotImage(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    reindexScreenshots(model: ReindexScreenshotsModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/screenshots/reindex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReindexScreenshots(_response);
        });
    }

    protected processReindexScreenshots(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class SessionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    getSessions(userId: string | null | undefined, username: string | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined, includeUserTags: number[] | null | undefined, includeOperator: LogicalOperator | null | undefined, excludeUserTags: number[] | null | undefined, excludeOperator: LogicalOperator | null | undefined, includeDialogTypes: DwsimProDialogType[] | undefined, orderBy: string | null | undefined, orderByDescending: boolean | null | undefined, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<SessionListResultModel> {
        let url_ = this.baseUrl + "/api/sessions?";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (username !== undefined && username !== null)
            url_ += "Username=" + encodeURIComponent("" + username) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (includeUserTags !== undefined && includeUserTags !== null)
            includeUserTags && includeUserTags.forEach(item => { url_ += "IncludeUserTags=" + encodeURIComponent("" + item) + "&"; });
        if (includeOperator !== undefined && includeOperator !== null)
            url_ += "IncludeOperator=" + encodeURIComponent("" + includeOperator) + "&";
        if (excludeUserTags !== undefined && excludeUserTags !== null)
            excludeUserTags && excludeUserTags.forEach(item => { url_ += "ExcludeUserTags=" + encodeURIComponent("" + item) + "&"; });
        if (excludeOperator !== undefined && excludeOperator !== null)
            url_ += "ExcludeOperator=" + encodeURIComponent("" + excludeOperator) + "&";
        if (includeDialogTypes === null)
            throw new globalThis.Error("The parameter 'includeDialogTypes' cannot be null.");
        else if (includeDialogTypes !== undefined)
            includeDialogTypes && includeDialogTypes.forEach(item => { url_ += "IncludeDialogTypes=" + encodeURIComponent("" + item) + "&"; });
        if (orderBy !== undefined && orderBy !== null)
            url_ += "OrderBy=" + encodeURIComponent("" + orderBy) + "&";
        if (orderByDescending !== undefined && orderByDescending !== null)
            url_ += "OrderByDescending=" + encodeURIComponent("" + orderByDescending) + "&";
        if (skip === null)
            throw new globalThis.Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new globalThis.Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSessions(_response);
        });
    }

    protected processGetSessions(response: AxiosResponse): Promise<SessionListResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SessionListResultModel.fromJS(resultData200);
            return Promise.resolve<SessionListResultModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SessionListResultModel>(null as any);
    }

    dialogShown(model: DialogShownPostModel, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/sessions/dailog-shown";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDialogShown(_response);
        });
    }

    protected processDialogShown(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class UploadScreenshotClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    uploadScreenshotMessage(username: string | undefined, computerName: string | undefined, screenshotFileName: string | undefined, action: string | null | undefined, windowsSessionId: string | null | undefined, createdAtUtc: Date | undefined, file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/screenshots/upload-screenshot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (username === null || username === undefined)
            throw new globalThis.Error("The parameter 'username' cannot be null.");
        else
            content_.append("Username", username.toString());
        if (computerName === null || computerName === undefined)
            throw new globalThis.Error("The parameter 'computerName' cannot be null.");
        else
            content_.append("ComputerName", computerName.toString());
        if (screenshotFileName === null || screenshotFileName === undefined)
            throw new globalThis.Error("The parameter 'screenshotFileName' cannot be null.");
        else
            content_.append("ScreenshotFileName", screenshotFileName.toString());
        if (action !== null && action !== undefined)
            content_.append("Action", action.toString());
        if (windowsSessionId !== null && windowsSessionId !== undefined)
            content_.append("WindowsSessionId", windowsSessionId.toString());
        if (createdAtUtc === null || createdAtUtc === undefined)
            throw new globalThis.Error("The parameter 'createdAtUtc' cannot be null.");
        else
            content_.append("CreatedAtUtc", createdAtUtc.toJSON());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadScreenshotMessage(_response);
        });
    }

    protected processUploadScreenshotMessage(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class EulaClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:8331";

    }

    eulaAccepted(model: EulaAcceptedPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/eula/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEulaAccepted(_response);
        });
    }

    protected processEulaAccepted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResultModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResultModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    syncAllEulaAcceptances( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/eula/sync-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncAllEulaAcceptances(_response);
        });
    }

    protected processSyncAllEulaAcceptances(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteAllUserEulaAcceptances( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/eula/delete-all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAllUserEulaAcceptances(_response);
        });
    }

    protected processDeleteAllUserEulaAcceptances(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ConsumerDomainsListResponseModel implements IConsumerDomainsListResponseModel {
    consumerDomains!: ConsumerDomainResponseModel[];
    totalRecords!: number;

    constructor(data?: IConsumerDomainsListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.consumerDomains = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["consumerDomains"])) {
                this.consumerDomains = [] as any;
                for (let item of _data["consumerDomains"])
                    this.consumerDomains!.push(ConsumerDomainResponseModel.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): ConsumerDomainsListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerDomainsListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.consumerDomains)) {
            data["consumerDomains"] = [];
            for (let item of this.consumerDomains)
                data["consumerDomains"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface IConsumerDomainsListResponseModel {
    consumerDomains: ConsumerDomainResponseModel[];
    totalRecords: number;
}

export class ConsumerDomainResponseModel implements IConsumerDomainResponseModel {
    domain!: string;
    createdAt!: Date;

    constructor(data?: IConsumerDomainResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ConsumerDomainResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerDomainResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IConsumerDomainResponseModel {
    domain: string;
    createdAt: Date;
}

export class ErrorResultModel implements IErrorResultModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (this.validationErrors as any)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (data["validationErrors"] as any)[key] = (this.validationErrors as any)[key];
            }
        }
        return data;
    }
}

export interface IErrorResultModel {
    errors?: string[] | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class ConsumerDomainPostModel implements IConsumerDomainPostModel {
    domain!: string;

    constructor(data?: IConsumerDomainPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): ConsumerDomainPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConsumerDomainPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        return data;
    }
}

export interface IConsumerDomainPostModel {
    domain: string;
}

export class UserAgentsResponseModel implements IUserAgentsResponseModel {
    userId!: string;
    user!: OwnerModel;
    uncalculatedJobs!: SimulatorCount;
    calculatingJobs!: SimulatorCount;
    availableAgents!: SimulatorCount;
    personalAgents!: SimulatorCount;

    constructor(data?: IUserAgentsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new OwnerModel();
            this.uncalculatedJobs = new SimulatorCount();
            this.calculatingJobs = new SimulatorCount();
            this.availableAgents = new SimulatorCount();
            this.personalAgents = new SimulatorCount();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? OwnerModel.fromJS(_data["user"]) : new OwnerModel();
            this.uncalculatedJobs = _data["uncalculatedJobs"] ? SimulatorCount.fromJS(_data["uncalculatedJobs"]) : new SimulatorCount();
            this.calculatingJobs = _data["calculatingJobs"] ? SimulatorCount.fromJS(_data["calculatingJobs"]) : new SimulatorCount();
            this.availableAgents = _data["availableAgents"] ? SimulatorCount.fromJS(_data["availableAgents"]) : new SimulatorCount();
            this.personalAgents = _data["personalAgents"] ? SimulatorCount.fromJS(_data["personalAgents"]) : new SimulatorCount();
        }
    }

    static fromJS(data: any): UserAgentsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAgentsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["uncalculatedJobs"] = this.uncalculatedJobs ? this.uncalculatedJobs.toJSON() : undefined as any;
        data["calculatingJobs"] = this.calculatingJobs ? this.calculatingJobs.toJSON() : undefined as any;
        data["availableAgents"] = this.availableAgents ? this.availableAgents.toJSON() : undefined as any;
        data["personalAgents"] = this.personalAgents ? this.personalAgents.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserAgentsResponseModel {
    userId: string;
    user: OwnerModel;
    uncalculatedJobs: SimulatorCount;
    calculatingJobs: SimulatorCount;
    availableAgents: SimulatorCount;
    personalAgents: SimulatorCount;
}

export class OwnerModel implements IOwnerModel {
    id?: string | undefined;
    displayName!: string;
    userPrincipalName!: string;

    constructor(data?: IOwnerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): OwnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["userPrincipalName"] = this.userPrincipalName;
        return data;
    }
}

export interface IOwnerModel {
    id?: string | undefined;
    displayName: string;
    userPrincipalName: string;
}

export class SimulatorCount implements ISimulatorCount {
    cC7!: number;
    cC8!: number;
    dwsim!: number;

    constructor(data?: ISimulatorCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cC7 = _data["cC7"];
            this.cC8 = _data["cC8"];
            this.dwsim = _data["dwsim"];
        }
    }

    static fromJS(data: any): SimulatorCount {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cC7"] = this.cC7;
        data["cC8"] = this.cC8;
        data["dwsim"] = this.dwsim;
        return data;
    }
}

export interface ISimulatorCount {
    cC7: number;
    cC8: number;
    dwsim: number;
}

export class DwsimProUsagePerUserModel implements IDwsimProUsagePerUserModel {
    last7Days?: LastXDaysModel | undefined;
    last30Days?: LastXDaysModel | undefined;
    last365Days?: LastXDaysModel | undefined;
    lastVisit?: Date | undefined;
    maxRowsLoaded!: boolean;

    constructor(data?: IDwsimProUsagePerUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.last7Days = _data["last7Days"] ? LastXDaysModel.fromJS(_data["last7Days"]) : undefined as any;
            this.last30Days = _data["last30Days"] ? LastXDaysModel.fromJS(_data["last30Days"]) : undefined as any;
            this.last365Days = _data["last365Days"] ? LastXDaysModel.fromJS(_data["last365Days"]) : undefined as any;
            this.lastVisit = _data["lastVisit"] ? new Date(_data["lastVisit"].toString()) : undefined as any;
            this.maxRowsLoaded = _data["maxRowsLoaded"];
        }
    }

    static fromJS(data: any): DwsimProUsagePerUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new DwsimProUsagePerUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["last7Days"] = this.last7Days ? this.last7Days.toJSON() : undefined as any;
        data["last30Days"] = this.last30Days ? this.last30Days.toJSON() : undefined as any;
        data["last365Days"] = this.last365Days ? this.last365Days.toJSON() : undefined as any;
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : undefined as any;
        data["maxRowsLoaded"] = this.maxRowsLoaded;
        return data;
    }
}

export interface IDwsimProUsagePerUserModel {
    last7Days?: LastXDaysModel | undefined;
    last30Days?: LastXDaysModel | undefined;
    last365Days?: LastXDaysModel | undefined;
    lastVisit?: Date | undefined;
    maxRowsLoaded: boolean;
}

export class LastXDaysModel implements ILastXDaysModel {
    daysUsed!: number;
    screenshotsFound!: number;

    constructor(data?: ILastXDaysModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daysUsed = _data["daysUsed"];
            this.screenshotsFound = _data["screenshotsFound"];
        }
    }

    static fromJS(data: any): LastXDaysModel {
        data = typeof data === 'object' ? data : {};
        let result = new LastXDaysModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daysUsed"] = this.daysUsed;
        data["screenshotsFound"] = this.screenshotsFound;
        return data;
    }
}

export interface ILastXDaysModel {
    daysUsed: number;
    screenshotsFound: number;
}

export class GetDwsimProUsagePostModel implements IGetDwsimProUsagePostModel {
    usernameWithoutDomain!: string;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;

    constructor(data?: IGetDwsimProUsagePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usernameWithoutDomain = _data["usernameWithoutDomain"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : undefined as any;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetDwsimProUsagePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetDwsimProUsagePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usernameWithoutDomain"] = this.usernameWithoutDomain;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined as any;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetDwsimProUsagePostModel {
    usernameWithoutDomain: string;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
}

export class ListResultOfDwsimProLicenseModel implements IListResultOfDwsimProLicenseModel {
    totalRecords!: number;
    items!: DwsimProLicenseModel[];
    nextPageUrl?: string | undefined;

    constructor(data?: IListResultOfDwsimProLicenseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DwsimProLicenseModel.fromJS(item));
            }
            this.nextPageUrl = _data["nextPageUrl"];
        }
    }

    static fromJS(data: any): ListResultOfDwsimProLicenseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultOfDwsimProLicenseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextPageUrl"] = this.nextPageUrl;
        return data;
    }
}

export interface IListResultOfDwsimProLicenseModel {
    totalRecords: number;
    items: DwsimProLicenseModel[];
    nextPageUrl?: string | undefined;
}

export class UsageListResultOfDwsimProLicenseModel extends ListResultOfDwsimProLicenseModel implements IUsageListResultOfDwsimProLicenseModel {
    paidUsersCount!: number;
    trialUsersCount!: number;

    constructor(data?: IUsageListResultOfDwsimProLicenseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paidUsersCount = _data["paidUsersCount"];
            this.trialUsersCount = _data["trialUsersCount"];
        }
    }

    static override fromJS(data: any): UsageListResultOfDwsimProLicenseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UsageListResultOfDwsimProLicenseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidUsersCount"] = this.paidUsersCount;
        data["trialUsersCount"] = this.trialUsersCount;
        super.toJSON(data);
        return data;
    }
}

export interface IUsageListResultOfDwsimProLicenseModel extends IListResultOfDwsimProLicenseModel {
    paidUsersCount: number;
    trialUsersCount: number;
}

export class DwsimProLicenseModel implements IDwsimProLicenseModel {
    user?: UserSlimModel | undefined;
    plan!: string;
    createdAt!: Date;
    expiresAt!: Date;
    hasSubmittedOrganizationMail!: boolean;
    isConsulting!: boolean;
    isUniversity!: boolean;
    isCompany!: boolean;
    portalSource!: string;
    usernameWithoutDomain!: string;
    last7Days?: LastXDaysModel | undefined;
    last30Days?: LastXDaysModel | undefined;
    last365Days?: LastXDaysModel | undefined;
    lastVisit?: Date | undefined;

    constructor(data?: IDwsimProLicenseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserSlimModel.fromJS(_data["user"]) : undefined as any;
            this.plan = _data["plan"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.hasSubmittedOrganizationMail = _data["hasSubmittedOrganizationMail"];
            this.isConsulting = _data["isConsulting"];
            this.isUniversity = _data["isUniversity"];
            this.isCompany = _data["isCompany"];
            this.portalSource = _data["portalSource"];
            this.usernameWithoutDomain = _data["usernameWithoutDomain"];
            this.last7Days = _data["last7Days"] ? LastXDaysModel.fromJS(_data["last7Days"]) : undefined as any;
            this.last30Days = _data["last30Days"] ? LastXDaysModel.fromJS(_data["last30Days"]) : undefined as any;
            this.last365Days = _data["last365Days"] ? LastXDaysModel.fromJS(_data["last365Days"]) : undefined as any;
            this.lastVisit = _data["lastVisit"] ? new Date(_data["lastVisit"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DwsimProLicenseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DwsimProLicenseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["plan"] = this.plan;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["hasSubmittedOrganizationMail"] = this.hasSubmittedOrganizationMail;
        data["isConsulting"] = this.isConsulting;
        data["isUniversity"] = this.isUniversity;
        data["isCompany"] = this.isCompany;
        data["portalSource"] = this.portalSource;
        data["usernameWithoutDomain"] = this.usernameWithoutDomain;
        data["last7Days"] = this.last7Days ? this.last7Days.toJSON() : undefined as any;
        data["last30Days"] = this.last30Days ? this.last30Days.toJSON() : undefined as any;
        data["last365Days"] = this.last365Days ? this.last365Days.toJSON() : undefined as any;
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : undefined as any;
        return data;
    }
}

export interface IDwsimProLicenseModel {
    user?: UserSlimModel | undefined;
    plan: string;
    createdAt: Date;
    expiresAt: Date;
    hasSubmittedOrganizationMail: boolean;
    isConsulting: boolean;
    isUniversity: boolean;
    isCompany: boolean;
    portalSource: string;
    usernameWithoutDomain: string;
    last7Days?: LastXDaysModel | undefined;
    last30Days?: LastXDaysModel | undefined;
    last365Days?: LastXDaysModel | undefined;
    lastVisit?: Date | undefined;
}

export class UserSlimModel implements IUserSlimModel {
    id!: string;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;
    email?: string | undefined;
    businessEmail?: string | undefined;
    activityLevel!: UserActivityLevel;
    motherTickets!: UserSlimModel_MotherTicket[];

    constructor(data?: IUserSlimModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.motherTickets = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.email = _data["email"];
            this.businessEmail = _data["businessEmail"];
            this.activityLevel = _data["activityLevel"];
            if (Array.isArray(_data["motherTickets"])) {
                this.motherTickets = [] as any;
                for (let item of _data["motherTickets"])
                    this.motherTickets!.push(UserSlimModel_MotherTicket.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserSlimModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserSlimModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["userPrincipalName"] = this.userPrincipalName;
        data["email"] = this.email;
        data["businessEmail"] = this.businessEmail;
        data["activityLevel"] = this.activityLevel;
        if (Array.isArray(this.motherTickets)) {
            data["motherTickets"] = [];
            for (let item of this.motherTickets)
                data["motherTickets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserSlimModel {
    id: string;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;
    email?: string | undefined;
    businessEmail?: string | undefined;
    activityLevel: UserActivityLevel;
    motherTickets: UserSlimModel_MotherTicket[];
}

export enum UserActivityLevel {
    Red = 1,
    Orange = 2,
    Yellow = 3,
    Green = 4,
}

export class UserSlimModel_MotherTicket implements IUserSlimModel_MotherTicket {
    id!: number;
    name!: string;
    totalUsersCount!: number;
    tags!: MotherTicketTagResponseModel[];

    constructor(data?: IUserSlimModel_MotherTicket) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.totalUsersCount = _data["totalUsersCount"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(MotherTicketTagResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserSlimModel_MotherTicket {
        data = typeof data === 'object' ? data : {};
        let result = new UserSlimModel_MotherTicket();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["totalUsersCount"] = this.totalUsersCount;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserSlimModel_MotherTicket {
    id: number;
    name: string;
    totalUsersCount: number;
    tags: MotherTicketTagResponseModel[];
}

export class MotherTicketTagResponseModel implements IMotherTicketTagResponseModel {
    id!: number;
    code?: string | undefined;
    name!: string;
    parentTagId?: number | undefined;
    systemTag!: boolean;
    targetProcessTag?: string | undefined;
    icon?: string | undefined;
    showWithName!: boolean;

    constructor(data?: IMotherTicketTagResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.parentTagId = _data["parentTagId"];
            this.systemTag = _data["systemTag"];
            this.targetProcessTag = _data["targetProcessTag"];
            this.icon = _data["icon"];
            this.showWithName = _data["showWithName"];
        }
    }

    static fromJS(data: any): MotherTicketTagResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MotherTicketTagResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["parentTagId"] = this.parentTagId;
        data["systemTag"] = this.systemTag;
        data["targetProcessTag"] = this.targetProcessTag;
        data["icon"] = this.icon;
        data["showWithName"] = this.showWithName;
        return data;
    }
}

export interface IMotherTicketTagResponseModel {
    id: number;
    code?: string | undefined;
    name: string;
    parentTagId?: number | undefined;
    systemTag: boolean;
    targetProcessTag?: string | undefined;
    icon?: string | undefined;
    showWithName: boolean;
}

export enum OrganizationType {
    University = 0,
    Company = 1,
    Consulting = 2,
}

export class DwsimProUserLicenseResponseModel implements IDwsimProUserLicenseResponseModel {
    hasLicense!: boolean;
    plan?: string | undefined;
    expiresAt?: Date | undefined;

    constructor(data?: IDwsimProUserLicenseResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasLicense = _data["hasLicense"];
            this.plan = _data["plan"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DwsimProUserLicenseResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DwsimProUserLicenseResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasLicense"] = this.hasLicense;
        data["plan"] = this.plan;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IDwsimProUserLicenseResponseModel {
    hasLicense: boolean;
    plan?: string | undefined;
    expiresAt?: Date | undefined;
}

export class DomainMotherTicketResponseModel implements IDomainMotherTicketResponseModel {
    motherTicketId?: number | undefined;
    ticketName!: string;

    constructor(data?: IDomainMotherTicketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.motherTicketId = _data["motherTicketId"];
            this.ticketName = _data["ticketName"];
        }
    }

    static fromJS(data: any): DomainMotherTicketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DomainMotherTicketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motherTicketId"] = this.motherTicketId;
        data["ticketName"] = this.ticketName;
        return data;
    }
}

export interface IDomainMotherTicketResponseModel {
    motherTicketId?: number | undefined;
    ticketName: string;
}

export class DomainMotherTicketPostModel implements IDomainMotherTicketPostModel {
    domain!: string;

    constructor(data?: IDomainMotherTicketPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domain = _data["domain"];
        }
    }

    static fromJS(data: any): DomainMotherTicketPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new DomainMotherTicketPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domain"] = this.domain;
        return data;
    }
}

export interface IDomainMotherTicketPostModel {
    domain: string;
}

export class HostPoolResultModel implements IHostPoolResultModel {
    id!: string;
    name!: string;
    maxSessionLimit!: number;
    hostPoolType!: string;
    resourceGroupName!: string;

    constructor(data?: IHostPoolResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.maxSessionLimit = _data["maxSessionLimit"];
            this.hostPoolType = _data["hostPoolType"];
            this.resourceGroupName = _data["resourceGroupName"];
        }
    }

    static fromJS(data: any): HostPoolResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new HostPoolResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["maxSessionLimit"] = this.maxSessionLimit;
        data["hostPoolType"] = this.hostPoolType;
        data["resourceGroupName"] = this.resourceGroupName;
        return data;
    }
}

export interface IHostPoolResultModel {
    id: string;
    name: string;
    maxSessionLimit: number;
    hostPoolType: string;
    resourceGroupName: string;
}

export class SessionHostModel implements ISessionHostModel {
    name!: string;
    selected!: boolean;
    userSessions!: UserSessionModel[];

    constructor(data?: ISessionHostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.userSessions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.selected = _data["selected"];
            if (Array.isArray(_data["userSessions"])) {
                this.userSessions = [] as any;
                for (let item of _data["userSessions"])
                    this.userSessions!.push(UserSessionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionHostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SessionHostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["selected"] = this.selected;
        if (Array.isArray(this.userSessions)) {
            data["userSessions"] = [];
            for (let item of this.userSessions)
                data["userSessions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISessionHostModel {
    name: string;
    selected: boolean;
    userSessions: UserSessionModel[];
}

export class UserSessionModel implements IUserSessionModel {
    userSessionName!: string;
    userName!: string;
    sessionState!: string;
    selected!: boolean;
    user?: UserSlimModel | undefined;

    constructor(data?: IUserSessionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userSessionName = _data["userSessionName"];
            this.userName = _data["userName"];
            this.sessionState = _data["sessionState"];
            this.selected = _data["selected"];
            this.user = _data["user"] ? UserSlimModel.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserSessionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserSessionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userSessionName"] = this.userSessionName;
        data["userName"] = this.userName;
        data["sessionState"] = this.sessionState;
        data["selected"] = this.selected;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserSessionModel {
    userSessionName: string;
    userName: string;
    sessionState: string;
    selected: boolean;
    user?: UserSlimModel | undefined;
}

export class NotificationResultModel implements INotificationResultModel {
    isStatusSuccess!: boolean;
    notSentToUsers!: string[];

    constructor(data?: INotificationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.notSentToUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isStatusSuccess = _data["isStatusSuccess"];
            if (Array.isArray(_data["notSentToUsers"])) {
                this.notSentToUsers = [] as any;
                for (let item of _data["notSentToUsers"])
                    this.notSentToUsers!.push(item);
            }
        }
    }

    static fromJS(data: any): NotificationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isStatusSuccess"] = this.isStatusSuccess;
        if (Array.isArray(this.notSentToUsers)) {
            data["notSentToUsers"] = [];
            for (let item of this.notSentToUsers)
                data["notSentToUsers"].push(item);
        }
        return data;
    }
}

export interface INotificationResultModel {
    isStatusSuccess: boolean;
    notSentToUsers: string[];
}

export class NotificationPostModel implements INotificationPostModel {
    title!: string;
    message!: string;
    sessionHosts!: SessionHostModel[];

    constructor(data?: INotificationPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sessionHosts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.message = _data["message"];
            if (Array.isArray(_data["sessionHosts"])) {
                this.sessionHosts = [] as any;
                for (let item of _data["sessionHosts"])
                    this.sessionHosts!.push(SessionHostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["message"] = this.message;
        if (Array.isArray(this.sessionHosts)) {
            data["sessionHosts"] = [];
            for (let item of this.sessionHosts)
                data["sessionHosts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INotificationPostModel {
    title: string;
    message: string;
    sessionHosts: SessionHostModel[];
}

export class ListResultOfMotherTicketForListResponseModel implements IListResultOfMotherTicketForListResponseModel {
    totalRecords!: number;
    items!: MotherTicketForListResponseModel[];
    nextPageUrl?: string | undefined;

    constructor(data?: IListResultOfMotherTicketForListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MotherTicketForListResponseModel.fromJS(item));
            }
            this.nextPageUrl = _data["nextPageUrl"];
        }
    }

    static fromJS(data: any): ListResultOfMotherTicketForListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultOfMotherTicketForListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextPageUrl"] = this.nextPageUrl;
        return data;
    }
}

export interface IListResultOfMotherTicketForListResponseModel {
    totalRecords: number;
    items: MotherTicketForListResponseModel[];
    nextPageUrl?: string | undefined;
}

export class MotherTicketForListResponseModel implements IMotherTicketForListResponseModel {
    id!: number;
    name!: string;
    isHidden!: boolean;
    cratedAt!: Date;
    numberOfUsers?: number | undefined;
    numberOfTrialLicenses?: number | undefined;
    numberOfPaidLicenses?: number | undefined;
    usersWithTrialLicenses?: number | undefined;
    usersWithPaidLicenses?: number | undefined;
    numberOfRegistrantsForUserMeeting?: number | undefined;
    numberOfParticipantsForUserMeeting?: number | undefined;
    motherTicketTags!: MotherTicketTagResponseModel[];

    constructor(data?: IMotherTicketForListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.motherTicketTags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isHidden = _data["isHidden"];
            this.cratedAt = _data["cratedAt"] ? new Date(_data["cratedAt"].toString()) : undefined as any;
            this.numberOfUsers = _data["numberOfUsers"];
            this.numberOfTrialLicenses = _data["numberOfTrialLicenses"];
            this.numberOfPaidLicenses = _data["numberOfPaidLicenses"];
            this.usersWithTrialLicenses = _data["usersWithTrialLicenses"];
            this.usersWithPaidLicenses = _data["usersWithPaidLicenses"];
            this.numberOfRegistrantsForUserMeeting = _data["numberOfRegistrantsForUserMeeting"];
            this.numberOfParticipantsForUserMeeting = _data["numberOfParticipantsForUserMeeting"];
            if (Array.isArray(_data["motherTicketTags"])) {
                this.motherTicketTags = [] as any;
                for (let item of _data["motherTicketTags"])
                    this.motherTicketTags!.push(MotherTicketTagResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MotherTicketForListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new MotherTicketForListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isHidden"] = this.isHidden;
        data["cratedAt"] = this.cratedAt ? this.cratedAt.toISOString() : undefined as any;
        data["numberOfUsers"] = this.numberOfUsers;
        data["numberOfTrialLicenses"] = this.numberOfTrialLicenses;
        data["numberOfPaidLicenses"] = this.numberOfPaidLicenses;
        data["usersWithTrialLicenses"] = this.usersWithTrialLicenses;
        data["usersWithPaidLicenses"] = this.usersWithPaidLicenses;
        data["numberOfRegistrantsForUserMeeting"] = this.numberOfRegistrantsForUserMeeting;
        data["numberOfParticipantsForUserMeeting"] = this.numberOfParticipantsForUserMeeting;
        if (Array.isArray(this.motherTicketTags)) {
            data["motherTicketTags"] = [];
            for (let item of this.motherTicketTags)
                data["motherTicketTags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMotherTicketForListResponseModel {
    id: number;
    name: string;
    isHidden: boolean;
    cratedAt: Date;
    numberOfUsers?: number | undefined;
    numberOfTrialLicenses?: number | undefined;
    numberOfPaidLicenses?: number | undefined;
    usersWithTrialLicenses?: number | undefined;
    usersWithPaidLicenses?: number | undefined;
    numberOfRegistrantsForUserMeeting?: number | undefined;
    numberOfParticipantsForUserMeeting?: number | undefined;
    motherTicketTags: MotherTicketTagResponseModel[];
}

export enum LogicalOperator {
    And = 0,
    Or = 1,
}

export class CreateMotherTicketResponseModel implements ICreateMotherTicketResponseModel {
    targetProcessTicketId!: number;

    constructor(data?: ICreateMotherTicketResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetProcessTicketId = _data["targetProcessTicketId"];
        }
    }

    static fromJS(data: any): CreateMotherTicketResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMotherTicketResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetProcessTicketId"] = this.targetProcessTicketId;
        return data;
    }
}

export interface ICreateMotherTicketResponseModel {
    targetProcessTicketId: number;
}

export class MotherTicketPostModel implements IMotherTicketPostModel {
    ticketName!: string;
    domain1!: string;
    domain2!: string;
    domain3!: string;
    domain4!: string;
    domain5!: string;

    constructor(data?: IMotherTicketPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticketName = _data["ticketName"];
            this.domain1 = _data["domain1"];
            this.domain2 = _data["domain2"];
            this.domain3 = _data["domain3"];
            this.domain4 = _data["domain4"];
            this.domain5 = _data["domain5"];
        }
    }

    static fromJS(data: any): MotherTicketPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new MotherTicketPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticketName"] = this.ticketName;
        data["domain1"] = this.domain1;
        data["domain2"] = this.domain2;
        data["domain3"] = this.domain3;
        data["domain4"] = this.domain4;
        data["domain5"] = this.domain5;
        return data;
    }
}

export interface IMotherTicketPostModel {
    ticketName: string;
    domain1: string;
    domain2: string;
    domain3: string;
    domain4: string;
    domain5: string;
}

export class MotherTicketCreatedOrUpdatedEventModel implements IMotherTicketCreatedOrUpdatedEventModel {
    motherTicketId!: number;

    constructor(data?: IMotherTicketCreatedOrUpdatedEventModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.motherTicketId = _data["motherTicketId"];
        }
    }

    static fromJS(data: any): MotherTicketCreatedOrUpdatedEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new MotherTicketCreatedOrUpdatedEventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["motherTicketId"] = this.motherTicketId;
        return data;
    }
}

export interface IMotherTicketCreatedOrUpdatedEventModel {
    motherTicketId: number;
}

export class DuplicateMotherTicketDomainResponseModel implements IDuplicateMotherTicketDomainResponseModel {
    domainName!: string;
    ticketIds!: number[];

    constructor(data?: IDuplicateMotherTicketDomainResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.ticketIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainName = _data["domainName"];
            if (Array.isArray(_data["ticketIds"])) {
                this.ticketIds = [] as any;
                for (let item of _data["ticketIds"])
                    this.ticketIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DuplicateMotherTicketDomainResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateMotherTicketDomainResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainName"] = this.domainName;
        if (Array.isArray(this.ticketIds)) {
            data["ticketIds"] = [];
            for (let item of this.ticketIds)
                data["ticketIds"].push(item);
        }
        return data;
    }
}

export interface IDuplicateMotherTicketDomainResponseModel {
    domainName: string;
    ticketIds: number[];
}

export class DwsimProUserAnalytics implements IDwsimProUserAnalytics {
    username?: string | undefined;
    displayName?: string | undefined;
    openedFromDashboard?: number | undefined;
    newFlowsheet?: number | undefined;
    solveFlowsheet?: number | undefined;
    converged?: number | undefined;
    notConverged?: number | undefined;
    propertyPackages?: number | undefined;
    objects?: number | undefined;
    components?: number | undefined;
    jsonImport?: number | undefined;
    onlineImport?: number | undefined;
    dynamicStarted?: number | undefined;
    dynamicFailed?: number | undefined;
    sensitivityStudy?: number | undefined;
    reporting?: number | undefined;

    constructor(data?: IDwsimProUserAnalytics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.displayName = _data["displayName"];
            this.openedFromDashboard = _data["openedFromDashboard"];
            this.newFlowsheet = _data["newFlowsheet"];
            this.solveFlowsheet = _data["solveFlowsheet"];
            this.converged = _data["converged"];
            this.notConverged = _data["notConverged"];
            this.propertyPackages = _data["propertyPackages"];
            this.objects = _data["objects"];
            this.components = _data["components"];
            this.jsonImport = _data["jsonImport"];
            this.onlineImport = _data["onlineImport"];
            this.dynamicStarted = _data["dynamicStarted"];
            this.dynamicFailed = _data["dynamicFailed"];
            this.sensitivityStudy = _data["sensitivityStudy"];
            this.reporting = _data["reporting"];
        }
    }

    static fromJS(data: any): DwsimProUserAnalytics {
        data = typeof data === 'object' ? data : {};
        let result = new DwsimProUserAnalytics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        data["openedFromDashboard"] = this.openedFromDashboard;
        data["newFlowsheet"] = this.newFlowsheet;
        data["solveFlowsheet"] = this.solveFlowsheet;
        data["converged"] = this.converged;
        data["notConverged"] = this.notConverged;
        data["propertyPackages"] = this.propertyPackages;
        data["objects"] = this.objects;
        data["components"] = this.components;
        data["jsonImport"] = this.jsonImport;
        data["onlineImport"] = this.onlineImport;
        data["dynamicStarted"] = this.dynamicStarted;
        data["dynamicFailed"] = this.dynamicFailed;
        data["sensitivityStudy"] = this.sensitivityStudy;
        data["reporting"] = this.reporting;
        return data;
    }
}

export interface IDwsimProUserAnalytics {
    username?: string | undefined;
    displayName?: string | undefined;
    openedFromDashboard?: number | undefined;
    newFlowsheet?: number | undefined;
    solveFlowsheet?: number | undefined;
    converged?: number | undefined;
    notConverged?: number | undefined;
    propertyPackages?: number | undefined;
    objects?: number | undefined;
    components?: number | undefined;
    jsonImport?: number | undefined;
    onlineImport?: number | undefined;
    dynamicStarted?: number | undefined;
    dynamicFailed?: number | undefined;
    sensitivityStudy?: number | undefined;
    reporting?: number | undefined;
}

export class DwsimProUserAnalyticsResponseModel extends DwsimProUserAnalytics implements IDwsimProUserAnalyticsResponseModel {
    isPaid!: boolean;

    constructor(data?: IDwsimProUserAnalyticsResponseModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isPaid = _data["isPaid"];
        }
    }

    static override fromJS(data: any): DwsimProUserAnalyticsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DwsimProUserAnalyticsResponseModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPaid"] = this.isPaid;
        super.toJSON(data);
        return data;
    }
}

export interface IDwsimProUserAnalyticsResponseModel extends IDwsimProUserAnalytics {
    isPaid: boolean;
}

export class SyncUsersStatusResponseModel implements ISyncUsersStatusResponseModel {
    isActive!: boolean;
    messages?: SyncStatusMessage[] | undefined;
    totalUsers!: number;
    processedUsers!: number;

    constructor(data?: ISyncUsersStatusResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(SyncStatusMessage.fromJS(item));
            }
            this.totalUsers = _data["totalUsers"];
            this.processedUsers = _data["processedUsers"];
        }
    }

    static fromJS(data: any): SyncUsersStatusResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SyncUsersStatusResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalUsers"] = this.totalUsers;
        data["processedUsers"] = this.processedUsers;
        return data;
    }
}

export interface ISyncUsersStatusResponseModel {
    isActive: boolean;
    messages?: SyncStatusMessage[] | undefined;
    totalUsers: number;
    processedUsers: number;
}

export class SyncStatusMessage implements ISyncStatusMessage {
    statusAt!: Date;
    message?: string | undefined;

    constructor(data?: ISyncStatusMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusAt = _data["statusAt"] ? new Date(_data["statusAt"].toString()) : undefined as any;
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SyncStatusMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SyncStatusMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusAt"] = this.statusAt ? this.statusAt.toISOString() : undefined as any;
        data["message"] = this.message;
        return data;
    }
}

export interface ISyncStatusMessage {
    statusAt: Date;
    message?: string | undefined;
}

export class UserPriceCheckLogsListResponseModel implements IUserPriceCheckLogsListResponseModel {
    items!: UserPriceCheckLogResponseModel[];
    totalItems!: number;

    constructor(data?: IUserPriceCheckLogsListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserPriceCheckLogResponseModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): UserPriceCheckLogsListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPriceCheckLogsListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IUserPriceCheckLogsListResponseModel {
    items: UserPriceCheckLogResponseModel[];
    totalItems: number;
}

export class UserPriceCheckLogResponseModel implements IUserPriceCheckLogResponseModel {
    id!: number;
    user!: UserSlimModel;
    hours!: number;
    engineers!: number;
    months!: number;
    calledAtUtc!: Date;
    yourPrice!: number;
    pricePerHour!: number;
    yourDiscount!: number;
    pricePerMonth!: number;
    pricePerEngineerMonth!: number;
    pricePerDay!: number;
    pricePerEngineerDay!: number;
    hoursPerMonth!: number;
    hoursPerEngineerMonth!: number;

    constructor(data?: IUserPriceCheckLogResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new UserSlimModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserSlimModel.fromJS(_data["user"]) : new UserSlimModel();
            this.hours = _data["hours"];
            this.engineers = _data["engineers"];
            this.months = _data["months"];
            this.calledAtUtc = _data["calledAtUtc"] ? new Date(_data["calledAtUtc"].toString()) : undefined as any;
            this.yourPrice = _data["yourPrice"];
            this.pricePerHour = _data["pricePerHour"];
            this.yourDiscount = _data["yourDiscount"];
            this.pricePerMonth = _data["pricePerMonth"];
            this.pricePerEngineerMonth = _data["pricePerEngineerMonth"];
            this.pricePerDay = _data["pricePerDay"];
            this.pricePerEngineerDay = _data["pricePerEngineerDay"];
            this.hoursPerMonth = _data["hoursPerMonth"];
            this.hoursPerEngineerMonth = _data["hoursPerEngineerMonth"];
        }
    }

    static fromJS(data: any): UserPriceCheckLogResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPriceCheckLogResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["hours"] = this.hours;
        data["engineers"] = this.engineers;
        data["months"] = this.months;
        data["calledAtUtc"] = this.calledAtUtc ? this.calledAtUtc.toISOString() : undefined as any;
        data["yourPrice"] = this.yourPrice;
        data["pricePerHour"] = this.pricePerHour;
        data["yourDiscount"] = this.yourDiscount;
        data["pricePerMonth"] = this.pricePerMonth;
        data["pricePerEngineerMonth"] = this.pricePerEngineerMonth;
        data["pricePerDay"] = this.pricePerDay;
        data["pricePerEngineerDay"] = this.pricePerEngineerDay;
        data["hoursPerMonth"] = this.hoursPerMonth;
        data["hoursPerEngineerMonth"] = this.hoursPerEngineerMonth;
        return data;
    }
}

export interface IUserPriceCheckLogResponseModel {
    id: number;
    user: UserSlimModel;
    hours: number;
    engineers: number;
    months: number;
    calledAtUtc: Date;
    yourPrice: number;
    pricePerHour: number;
    yourDiscount: number;
    pricePerMonth: number;
    pricePerEngineerMonth: number;
    pricePerDay: number;
    pricePerEngineerDay: number;
    hoursPerMonth: number;
    hoursPerEngineerMonth: number;
}

export class GetPriceTrackPostModel implements IGetPriceTrackPostModel {
    userId!: string;
    hours!: number;
    engineers!: number;
    months!: number;
    calledAtUtc!: Date;
    yourPrice!: number;
    pricePerHour!: number;
    yourDiscount!: number;
    pricePerMonth!: number;
    pricePerEngineerMonth!: number;
    pricePerDay!: number;
    pricePerEngineerDay!: number;
    hoursPerMonth!: number;
    hoursPerEngineerMonth!: number;

    constructor(data?: IGetPriceTrackPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.hours = _data["hours"];
            this.engineers = _data["engineers"];
            this.months = _data["months"];
            this.calledAtUtc = _data["calledAtUtc"] ? new Date(_data["calledAtUtc"].toString()) : undefined as any;
            this.yourPrice = _data["yourPrice"];
            this.pricePerHour = _data["pricePerHour"];
            this.yourDiscount = _data["yourDiscount"];
            this.pricePerMonth = _data["pricePerMonth"];
            this.pricePerEngineerMonth = _data["pricePerEngineerMonth"];
            this.pricePerDay = _data["pricePerDay"];
            this.pricePerEngineerDay = _data["pricePerEngineerDay"];
            this.hoursPerMonth = _data["hoursPerMonth"];
            this.hoursPerEngineerMonth = _data["hoursPerEngineerMonth"];
        }
    }

    static fromJS(data: any): GetPriceTrackPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new GetPriceTrackPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["hours"] = this.hours;
        data["engineers"] = this.engineers;
        data["months"] = this.months;
        data["calledAtUtc"] = this.calledAtUtc ? this.calledAtUtc.toISOString() : undefined as any;
        data["yourPrice"] = this.yourPrice;
        data["pricePerHour"] = this.pricePerHour;
        data["yourDiscount"] = this.yourDiscount;
        data["pricePerMonth"] = this.pricePerMonth;
        data["pricePerEngineerMonth"] = this.pricePerEngineerMonth;
        data["pricePerDay"] = this.pricePerDay;
        data["pricePerEngineerDay"] = this.pricePerEngineerDay;
        data["hoursPerMonth"] = this.hoursPerMonth;
        data["hoursPerEngineerMonth"] = this.hoursPerEngineerMonth;
        return data;
    }
}

export interface IGetPriceTrackPostModel {
    userId: string;
    hours: number;
    engineers: number;
    months: number;
    calledAtUtc: Date;
    yourPrice: number;
    pricePerHour: number;
    yourDiscount: number;
    pricePerMonth: number;
    pricePerEngineerMonth: number;
    pricePerDay: number;
    pricePerEngineerDay: number;
    hoursPerMonth: number;
    hoursPerEngineerMonth: number;
}

export class SubmitAnswersPostModel implements ISubmitAnswersPostModel {
    questionaireCode!: string;
    userId!: string;
    environment!: string;
    answers!: { [key: string]: string; };

    constructor(data?: ISubmitAnswersPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.answers = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionaireCode = _data["questionaireCode"];
            this.userId = _data["userId"];
            this.environment = _data["environment"];
            if (_data["answers"]) {
                this.answers = {} as any;
                for (let key in _data["answers"]) {
                    if (_data["answers"].hasOwnProperty(key))
                        (this.answers as any)![key] = _data["answers"][key];
                }
            }
        }
    }

    static fromJS(data: any): SubmitAnswersPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitAnswersPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionaireCode"] = this.questionaireCode;
        data["userId"] = this.userId;
        data["environment"] = this.environment;
        if (this.answers) {
            data["answers"] = {};
            for (let key in this.answers) {
                if (this.answers.hasOwnProperty(key))
                    (data["answers"] as any)[key] = (this.answers as any)[key];
            }
        }
        return data;
    }
}

export interface ISubmitAnswersPostModel {
    questionaireCode: string;
    userId: string;
    environment: string;
    answers: { [key: string]: string; };
}

export class ListResultOfQuestionaireResponseModel implements IListResultOfQuestionaireResponseModel {
    totalRecords!: number;
    items!: QuestionaireResponseModel[];
    nextPageUrl?: string | undefined;

    constructor(data?: IListResultOfQuestionaireResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionaireResponseModel.fromJS(item));
            }
            this.nextPageUrl = _data["nextPageUrl"];
        }
    }

    static fromJS(data: any): ListResultOfQuestionaireResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultOfQuestionaireResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextPageUrl"] = this.nextPageUrl;
        return data;
    }
}

export interface IListResultOfQuestionaireResponseModel {
    totalRecords: number;
    items: QuestionaireResponseModel[];
    nextPageUrl?: string | undefined;
}

export class QuestionaireResponseModel implements IQuestionaireResponseModel {
    userId!: string;
    user!: UserSlimModel;
    createdAtUtc!: Date;
    questions!: QuestionareAnswerResponseModel[];

    constructor(data?: IQuestionaireResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.user = new UserSlimModel();
            this.questions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserSlimModel.fromJS(_data["user"]) : new UserSlimModel();
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(QuestionareAnswerResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionaireResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionaireResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IQuestionaireResponseModel {
    userId: string;
    user: UserSlimModel;
    createdAtUtc: Date;
    questions: QuestionareAnswerResponseModel[];
}

export class QuestionareAnswerResponseModel implements IQuestionareAnswerResponseModel {
    questionCode!: string;
    answerId!: number;
    answer!: string;

    constructor(data?: IQuestionareAnswerResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionCode = _data["questionCode"];
            this.answerId = _data["answerId"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): QuestionareAnswerResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionareAnswerResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionCode"] = this.questionCode;
        data["answerId"] = this.answerId;
        data["answer"] = this.answer;
        return data;
    }
}

export interface IQuestionareAnswerResponseModel {
    questionCode: string;
    answerId: number;
    answer: string;
}

export class TestUsersListResponseModel implements ITestUsersListResponseModel {
    records!: TestUserResponseModel[];
    totalRecords!: number;

    constructor(data?: ITestUsersListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.records = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(TestUserResponseModel.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): TestUsersListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TestUsersListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface ITestUsersListResponseModel {
    records: TestUserResponseModel[];
    totalRecords: number;
}

export class TestUserResponseModel implements ITestUserResponseModel {
    id!: number;
    userId!: string;
    displayName!: string;
    usernameWithoutDomain!: string;
    privateEmail!: string;
    createdAtUtc!: Date;

    constructor(data?: ITestUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.displayName = _data["displayName"];
            this.usernameWithoutDomain = _data["usernameWithoutDomain"];
            this.privateEmail = _data["privateEmail"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TestUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new TestUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["displayName"] = this.displayName;
        data["usernameWithoutDomain"] = this.usernameWithoutDomain;
        data["privateEmail"] = this.privateEmail;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface ITestUserResponseModel {
    id: number;
    userId: string;
    displayName: string;
    usernameWithoutDomain: string;
    privateEmail: string;
    createdAtUtc: Date;
}

export class TestUserPostModel implements ITestUserPostModel {
    userId!: string;

    constructor(data?: ITestUserPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): TestUserPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new TestUserPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface ITestUserPostModel {
    userId: string;
}

export class UserLoginResponseModel implements IUserLoginResponseModel {
    id!: string;
    displayName!: string;
    userPrincipalName!: string;
    roles!: string[];

    constructor(data?: IUserLoginResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.userPrincipalName = _data["userPrincipalName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserLoginResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["userPrincipalName"] = this.userPrincipalName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserLoginResponseModel {
    id: string;
    displayName: string;
    userPrincipalName: string;
    roles: string[];
}

export class BlockUserPostModel implements IBlockUserPostModel {
    userId!: string;
    isAccountEnabled!: boolean;

    constructor(data?: IBlockUserPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.isAccountEnabled = _data["isAccountEnabled"];
        }
    }

    static fromJS(data: any): BlockUserPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["isAccountEnabled"] = this.isAccountEnabled;
        return data;
    }
}

export interface IBlockUserPostModel {
    userId: string;
    isAccountEnabled: boolean;
}

export class EnrichlayerLinkedInResponse implements IEnrichlayerLinkedInResponse {
    url!: string;

    constructor(data?: IEnrichlayerLinkedInResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): EnrichlayerLinkedInResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnrichlayerLinkedInResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IEnrichlayerLinkedInResponse {
    url: string;
}

export class EmailCategoryResponseModel implements IEmailCategoryResponseModel {
    emailCategory?: GeminiDomainCategory | undefined;

    constructor(data?: IEmailCategoryResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailCategory = _data["emailCategory"];
        }
    }

    static fromJS(data: any): EmailCategoryResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailCategoryResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailCategory"] = this.emailCategory;
        return data;
    }
}

export interface IEmailCategoryResponseModel {
    emailCategory?: GeminiDomainCategory | undefined;
}

export enum GeminiDomainCategory {
    Company = 0,
    University = 1,
    Other = 2,
}

export class EmailCategoryPostModel implements IEmailCategoryPostModel {
    email!: string;

    constructor(data?: IEmailCategoryPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EmailCategoryPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailCategoryPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IEmailCategoryPostModel {
    email: string;
}

export class UserResultModel implements IUserResultModel {
    id!: string;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;
    email?: string | undefined;
    businessEmail?: string | undefined;
    businessPhone?: string | undefined;
    isBusinesEmailConfirmed!: boolean;
    isBlocked!: boolean;
    linkedInUrl?: string | undefined;
    screenshotsCount?: number | undefined;
    motherTicket?: MotherTicketSlimModel | undefined;
    createdAt!: Date;
    activityLevel!: UserActivityLevel;
    readyToOrderCratedBy?: string | undefined;
    tags?: UsersTagResponseModel[] | undefined;

    constructor(data?: IUserResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.email = _data["email"];
            this.businessEmail = _data["businessEmail"];
            this.businessPhone = _data["businessPhone"];
            this.isBusinesEmailConfirmed = _data["isBusinesEmailConfirmed"];
            this.isBlocked = _data["isBlocked"];
            this.linkedInUrl = _data["linkedInUrl"];
            this.screenshotsCount = _data["screenshotsCount"];
            this.motherTicket = _data["motherTicket"] ? MotherTicketSlimModel.fromJS(_data["motherTicket"]) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.activityLevel = _data["activityLevel"];
            this.readyToOrderCratedBy = _data["readyToOrderCratedBy"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(UsersTagResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["userPrincipalName"] = this.userPrincipalName;
        data["email"] = this.email;
        data["businessEmail"] = this.businessEmail;
        data["businessPhone"] = this.businessPhone;
        data["isBusinesEmailConfirmed"] = this.isBusinesEmailConfirmed;
        data["isBlocked"] = this.isBlocked;
        data["linkedInUrl"] = this.linkedInUrl;
        data["screenshotsCount"] = this.screenshotsCount;
        data["motherTicket"] = this.motherTicket ? this.motherTicket.toJSON() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["activityLevel"] = this.activityLevel;
        data["readyToOrderCratedBy"] = this.readyToOrderCratedBy;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserResultModel {
    id: string;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;
    email?: string | undefined;
    businessEmail?: string | undefined;
    businessPhone?: string | undefined;
    isBusinesEmailConfirmed: boolean;
    isBlocked: boolean;
    linkedInUrl?: string | undefined;
    screenshotsCount?: number | undefined;
    motherTicket?: MotherTicketSlimModel | undefined;
    createdAt: Date;
    activityLevel: UserActivityLevel;
    readyToOrderCratedBy?: string | undefined;
    tags?: UsersTagResponseModel[] | undefined;
}

export class MotherTicketSlimModel implements IMotherTicketSlimModel {
    id!: number;
    name?: string | undefined;
    numberOfUsers?: number | undefined;
    tags?: MotherTicketTagResponseModel[] | undefined;

    constructor(data?: IMotherTicketSlimModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numberOfUsers = _data["numberOfUsers"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(MotherTicketTagResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MotherTicketSlimModel {
        data = typeof data === 'object' ? data : {};
        let result = new MotherTicketSlimModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numberOfUsers"] = this.numberOfUsers;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMotherTicketSlimModel {
    id: number;
    name?: string | undefined;
    numberOfUsers?: number | undefined;
    tags?: MotherTicketTagResponseModel[] | undefined;
}

export class UsersTagResponseModel implements IUsersTagResponseModel {
    userTagId!: number;
    name?: string | undefined;
    code?: string | undefined;
    isSystemTag!: boolean;
    color?: string | undefined;
    icon?: string | undefined;
    eventAtUtc?: Date | undefined;

    constructor(data?: IUsersTagResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTagId = _data["userTagId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isSystemTag = _data["isSystemTag"];
            this.color = _data["color"];
            this.icon = _data["icon"];
            this.eventAtUtc = _data["eventAtUtc"] ? new Date(_data["eventAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UsersTagResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UsersTagResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTagId"] = this.userTagId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isSystemTag"] = this.isSystemTag;
        data["color"] = this.color;
        data["icon"] = this.icon;
        data["eventAtUtc"] = this.eventAtUtc ? this.eventAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IUsersTagResponseModel {
    userTagId: number;
    name?: string | undefined;
    code?: string | undefined;
    isSystemTag: boolean;
    color?: string | undefined;
    icon?: string | undefined;
    eventAtUtc?: Date | undefined;
}

export class UserBusinessResponseModel implements IUserBusinessResponseModel {
    userId!: string;
    email?: string | undefined;
    emailType?: EmailType | undefined;
    isMailConfirmed!: boolean;
    motherTicketId?: number | undefined;
    readyToOrder!: boolean;

    constructor(data?: IUserBusinessResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.emailType = _data["emailType"];
            this.isMailConfirmed = _data["isMailConfirmed"];
            this.motherTicketId = _data["motherTicketId"];
            this.readyToOrder = _data["readyToOrder"];
        }
    }

    static fromJS(data: any): UserBusinessResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserBusinessResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["emailType"] = this.emailType;
        data["isMailConfirmed"] = this.isMailConfirmed;
        data["motherTicketId"] = this.motherTicketId;
        data["readyToOrder"] = this.readyToOrder;
        return data;
    }
}

export interface IUserBusinessResponseModel {
    userId: string;
    email?: string | undefined;
    emailType?: EmailType | undefined;
    isMailConfirmed: boolean;
    motherTicketId?: number | undefined;
    readyToOrder: boolean;
}

export enum EmailType {
    Consumer = 0,
    Business = 1,
}

export class ListResultOfUserResultModel implements IListResultOfUserResultModel {
    totalRecords!: number;
    items!: UserResultModel[];
    nextPageUrl?: string | undefined;

    constructor(data?: IListResultOfUserResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserResultModel.fromJS(item));
            }
            this.nextPageUrl = _data["nextPageUrl"];
        }
    }

    static fromJS(data: any): ListResultOfUserResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultOfUserResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextPageUrl"] = this.nextPageUrl;
        return data;
    }
}

export interface IListResultOfUserResultModel {
    totalRecords: number;
    items: UserResultModel[];
    nextPageUrl?: string | undefined;
}

export class ListResultOfUserTagResponseModel implements IListResultOfUserTagResponseModel {
    totalRecords!: number;
    items!: UserTagResponseModel[];
    nextPageUrl?: string | undefined;

    constructor(data?: IListResultOfUserTagResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRecords = _data["totalRecords"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserTagResponseModel.fromJS(item));
            }
            this.nextPageUrl = _data["nextPageUrl"];
        }
    }

    static fromJS(data: any): ListResultOfUserTagResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultOfUserTagResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRecords"] = this.totalRecords;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["nextPageUrl"] = this.nextPageUrl;
        return data;
    }
}

export interface IListResultOfUserTagResponseModel {
    totalRecords: number;
    items: UserTagResponseModel[];
    nextPageUrl?: string | undefined;
}

export class UserTagResponseModel implements IUserTagResponseModel {
    id!: number;
    name?: string | undefined;
    code?: string | undefined;
    parentTagId?: number | undefined;
    isSystemTag!: boolean;
    color?: string | undefined;
    icon?: string | undefined;
    createdAtUtc!: Date;

    constructor(data?: IUserTagResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.parentTagId = _data["parentTagId"];
            this.isSystemTag = _data["isSystemTag"];
            this.color = _data["color"];
            this.icon = _data["icon"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserTagResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserTagResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["parentTagId"] = this.parentTagId;
        data["isSystemTag"] = this.isSystemTag;
        data["color"] = this.color;
        data["icon"] = this.icon;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserTagResponseModel {
    id: number;
    name?: string | undefined;
    code?: string | undefined;
    parentTagId?: number | undefined;
    isSystemTag: boolean;
    color?: string | undefined;
    icon?: string | undefined;
    createdAtUtc: Date;
}

export class ReadyToOrderPostModel implements IReadyToOrderPostModel {
    userId!: string;
    canOrder!: boolean;

    constructor(data?: IReadyToOrderPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.canOrder = _data["canOrder"];
        }
    }

    static fromJS(data: any): ReadyToOrderPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReadyToOrderPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["canOrder"] = this.canOrder;
        return data;
    }
}

export interface IReadyToOrderPostModel {
    userId: string;
    canOrder: boolean;
}

export class UsersTagsListResponseModel implements IUsersTagsListResponseModel {
    tags!: string[];

    constructor(data?: IUsersTagsListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): UsersTagsListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UsersTagsListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IUsersTagsListResponseModel {
    tags: string[];
}

export class CreateUserTagPostModel implements ICreateUserTagPostModel {
    name!: string;

    constructor(data?: ICreateUserTagPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateUserTagPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserTagPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateUserTagPostModel {
    name: string;
}

export class AddUsersTagPostModel implements IAddUsersTagPostModel {
    tagId!: number;
    userId!: string;

    constructor(data?: IAddUsersTagPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AddUsersTagPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddUsersTagPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAddUsersTagPostModel {
    tagId: number;
    userId: string;
}

export class RemoveUsersTagPostModel implements IRemoveUsersTagPostModel {
    tagId!: number;
    userId!: string;

    constructor(data?: IRemoveUsersTagPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): RemoveUsersTagPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveUsersTagPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IRemoveUsersTagPostModel {
    tagId: number;
    userId: string;
}

export class LogUserActionPostModel implements ILogUserActionPostModel {
    userId!: string;
    userTagCode!: string;
    eventAt?: Date | undefined;

    constructor(data?: ILogUserActionPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userTagCode = _data["userTagCode"];
            this.eventAt = _data["eventAt"] ? new Date(_data["eventAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LogUserActionPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new LogUserActionPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userTagCode"] = this.userTagCode;
        data["eventAt"] = this.eventAt ? this.eventAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ILogUserActionPostModel {
    userId: string;
    userTagCode: string;
    eventAt?: Date | undefined;
}

export class WebinarResponseModel implements IWebinarResponseModel {
    id!: number;
    name!: string;
    webinarId!: string;
    eventAt!: Date;
    userTag?: string | undefined;
    userParticipantTagColor?: string | undefined;
    userParticipantTagIcon?: string | undefined;
    userRegistrantTagColor?: string | undefined;
    userRegistrantTagIcon?: string | undefined;
    userTagParentId?: number | undefined;
    zoomUserId!: string;
    zoomUser!: string;
    isReoccurring!: boolean;
    addCommentToTP!: boolean;
    isActive!: boolean;

    constructor(data?: IWebinarResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.webinarId = _data["webinarId"];
            this.eventAt = _data["eventAt"] ? new Date(_data["eventAt"].toString()) : undefined as any;
            this.userTag = _data["userTag"];
            this.userParticipantTagColor = _data["userParticipantTagColor"];
            this.userParticipantTagIcon = _data["userParticipantTagIcon"];
            this.userRegistrantTagColor = _data["userRegistrantTagColor"];
            this.userRegistrantTagIcon = _data["userRegistrantTagIcon"];
            this.userTagParentId = _data["userTagParentId"];
            this.zoomUserId = _data["zoomUserId"];
            this.zoomUser = _data["zoomUser"];
            this.isReoccurring = _data["isReoccurring"];
            this.addCommentToTP = _data["addCommentToTP"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): WebinarResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["webinarId"] = this.webinarId;
        data["eventAt"] = this.eventAt ? this.eventAt.toISOString() : undefined as any;
        data["userTag"] = this.userTag;
        data["userParticipantTagColor"] = this.userParticipantTagColor;
        data["userParticipantTagIcon"] = this.userParticipantTagIcon;
        data["userRegistrantTagColor"] = this.userRegistrantTagColor;
        data["userRegistrantTagIcon"] = this.userRegistrantTagIcon;
        data["userTagParentId"] = this.userTagParentId;
        data["zoomUserId"] = this.zoomUserId;
        data["zoomUser"] = this.zoomUser;
        data["isReoccurring"] = this.isReoccurring;
        data["addCommentToTP"] = this.addCommentToTP;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IWebinarResponseModel {
    id: number;
    name: string;
    webinarId: string;
    eventAt: Date;
    userTag?: string | undefined;
    userParticipantTagColor?: string | undefined;
    userParticipantTagIcon?: string | undefined;
    userRegistrantTagColor?: string | undefined;
    userRegistrantTagIcon?: string | undefined;
    userTagParentId?: number | undefined;
    zoomUserId: string;
    zoomUser: string;
    isReoccurring: boolean;
    addCommentToTP: boolean;
    isActive: boolean;
}

export class PagedListOfWebinarForListResponseModel implements IPagedListOfWebinarForListResponseModel {
    items!: WebinarForListResponseModel[];
    totalItems!: number;

    constructor(data?: IPagedListOfWebinarForListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WebinarForListResponseModel.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PagedListOfWebinarForListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListOfWebinarForListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPagedListOfWebinarForListResponseModel {
    items: WebinarForListResponseModel[];
    totalItems: number;
}

export class WebinarForListResponseModel implements IWebinarForListResponseModel {
    id!: number;
    name!: string;
    webinarId!: string;
    eventAt!: Date;
    zoomUser!: string;
    isReoccurring!: boolean;
    isActive!: boolean;

    constructor(data?: IWebinarForListResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.webinarId = _data["webinarId"];
            this.eventAt = _data["eventAt"] ? new Date(_data["eventAt"].toString()) : undefined as any;
            this.zoomUser = _data["zoomUser"];
            this.isReoccurring = _data["isReoccurring"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): WebinarForListResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebinarForListResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["webinarId"] = this.webinarId;
        data["eventAt"] = this.eventAt ? this.eventAt.toISOString() : undefined as any;
        data["zoomUser"] = this.zoomUser;
        data["isReoccurring"] = this.isReoccurring;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IWebinarForListResponseModel {
    id: number;
    name: string;
    webinarId: string;
    eventAt: Date;
    zoomUser: string;
    isReoccurring: boolean;
    isActive: boolean;
}

export class EditWebinarPostModel implements IEditWebinarPostModel {
    userTag!: string;
    userTagParentId!: number;
    userParticipantTagColor?: string | undefined;
    userParticipantTagIcon?: string | undefined;
    userRegistrantTagColor?: string | undefined;
    userRegistrantTagIcon?: string | undefined;
    addCommentToTP!: boolean;
    isActive!: boolean;

    constructor(data?: IEditWebinarPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userTag = _data["userTag"];
            this.userTagParentId = _data["userTagParentId"];
            this.userParticipantTagColor = _data["userParticipantTagColor"];
            this.userParticipantTagIcon = _data["userParticipantTagIcon"];
            this.userRegistrantTagColor = _data["userRegistrantTagColor"];
            this.userRegistrantTagIcon = _data["userRegistrantTagIcon"];
            this.addCommentToTP = _data["addCommentToTP"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EditWebinarPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditWebinarPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTag"] = this.userTag;
        data["userTagParentId"] = this.userTagParentId;
        data["userParticipantTagColor"] = this.userParticipantTagColor;
        data["userParticipantTagIcon"] = this.userParticipantTagIcon;
        data["userRegistrantTagColor"] = this.userRegistrantTagColor;
        data["userRegistrantTagIcon"] = this.userRegistrantTagIcon;
        data["addCommentToTP"] = this.addCommentToTP;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IEditWebinarPostModel {
    userTag: string;
    userTagParentId: number;
    userParticipantTagColor?: string | undefined;
    userParticipantTagIcon?: string | undefined;
    userRegistrantTagColor?: string | undefined;
    userRegistrantTagIcon?: string | undefined;
    addCommentToTP: boolean;
    isActive: boolean;
}

export class SyncWebinarsRunningModel implements ISyncWebinarsRunningModel {
    id!: string;
    total!: number;
    processed!: number;
    failed!: number;
    status!: SyncWebinarsStatus;
    startedAt!: Date;
    finishedAt?: Date | undefined;
    duration!: string;

    constructor(data?: ISyncWebinarsRunningModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.total = _data["total"];
            this.processed = _data["processed"];
            this.failed = _data["failed"];
            this.status = _data["status"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : undefined as any;
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): SyncWebinarsRunningModel {
        data = typeof data === 'object' ? data : {};
        let result = new SyncWebinarsRunningModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["total"] = this.total;
        data["processed"] = this.processed;
        data["failed"] = this.failed;
        data["status"] = this.status;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : undefined as any;
        data["duration"] = this.duration;
        return data;
    }
}

export interface ISyncWebinarsRunningModel {
    id: string;
    total: number;
    processed: number;
    failed: number;
    status: SyncWebinarsStatus;
    startedAt: Date;
    finishedAt?: Date | undefined;
    duration: string;
}

export enum SyncWebinarsStatus {
    Running = 0,
    Finished = 1,
    Failed = 2,
}

export class EventModel implements IEventModel {
    event?: string | undefined;
    event_ts?: number | undefined;
    payload?: EventPayload | undefined;

    constructor(data?: IEventModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.event_ts = _data["event_ts"];
            this.payload = _data["payload"] ? EventPayload.fromJS(_data["payload"]) : undefined as any;
        }
    }

    static fromJS(data: any): EventModel {
        data = typeof data === 'object' ? data : {};
        let result = new EventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["event_ts"] = this.event_ts;
        data["payload"] = this.payload ? this.payload.toJSON() : undefined as any;
        return data;
    }
}

export interface IEventModel {
    event?: string | undefined;
    event_ts?: number | undefined;
    payload?: EventPayload | undefined;
}

export class EventPayload implements IEventPayload {
    plainToken?: string | undefined;
    account_id?: string | undefined;
    operator?: string | undefined;
    operator_id?: string | undefined;
    object?: EventObject | undefined;

    constructor(data?: IEventPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plainToken = _data["plainToken"];
            this.account_id = _data["account_id"];
            this.operator = _data["operator"];
            this.operator_id = _data["operator_id"];
            this.object = _data["object"] ? EventObject.fromJS(_data["object"]) : undefined as any;
        }
    }

    static fromJS(data: any): EventPayload {
        data = typeof data === 'object' ? data : {};
        let result = new EventPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plainToken"] = this.plainToken;
        data["account_id"] = this.account_id;
        data["operator"] = this.operator;
        data["operator_id"] = this.operator_id;
        data["object"] = this.object ? this.object.toJSON() : undefined as any;
        return data;
    }
}

export interface IEventPayload {
    plainToken?: string | undefined;
    account_id?: string | undefined;
    operator?: string | undefined;
    operator_id?: string | undefined;
    object?: EventObject | undefined;
}

export class EventObject implements IEventObject {
    uuid?: string | undefined;
    id?: number | undefined;
    start_time?: Date | undefined;
    duration?: number | undefined;
    timezone?: string | undefined;
    occurrences!: EventOccurrence[];

    constructor(data?: IEventObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.occurrences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuid = _data["uuid"];
            this.id = _data["id"];
            this.start_time = _data["start_time"] ? new Date(_data["start_time"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.timezone = _data["timezone"];
            if (Array.isArray(_data["occurrences"])) {
                this.occurrences = [] as any;
                for (let item of _data["occurrences"])
                    this.occurrences!.push(EventOccurrence.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EventObject {
        data = typeof data === 'object' ? data : {};
        let result = new EventObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uuid"] = this.uuid;
        data["id"] = this.id;
        data["start_time"] = this.start_time ? this.start_time.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["timezone"] = this.timezone;
        if (Array.isArray(this.occurrences)) {
            data["occurrences"] = [];
            for (let item of this.occurrences)
                data["occurrences"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IEventObject {
    uuid?: string | undefined;
    id?: number | undefined;
    start_time?: Date | undefined;
    duration?: number | undefined;
    timezone?: string | undefined;
    occurrences: EventOccurrence[];
}

export class EventOccurrence implements IEventOccurrence {
    occurrence_id?: string | undefined;
    start_time?: Date | undefined;

    constructor(data?: IEventOccurrence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.occurrence_id = _data["occurrence_id"];
            this.start_time = _data["start_time"] ? new Date(_data["start_time"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EventOccurrence {
        data = typeof data === 'object' ? data : {};
        let result = new EventOccurrence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occurrence_id"] = this.occurrence_id;
        data["start_time"] = this.start_time ? this.start_time.toISOString() : undefined as any;
        return data;
    }
}

export interface IEventOccurrence {
    occurrence_id?: string | undefined;
    start_time?: Date | undefined;
}

export class UserPrincipalNameRequest implements IUserPrincipalNameRequest {
    username!: string;

    constructor(data?: IUserPrincipalNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): UserPrincipalNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserPrincipalNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        return data;
    }
}

export interface IUserPrincipalNameRequest {
    username: string;
}

export class SubmitBusinessEmailPostModel implements ISubmitBusinessEmailPostModel {
    email!: string;
    userId!: string;

    constructor(data?: ISubmitBusinessEmailPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): SubmitBusinessEmailPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitBusinessEmailPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ISubmitBusinessEmailPostModel {
    email: string;
    userId: string;
}

export class EmailConfirmedPostModel implements IEmailConfirmedPostModel {
    confirmationToken!: string;

    constructor(data?: IEmailConfirmedPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmationToken = _data["confirmationToken"];
        }
    }

    static fromJS(data: any): EmailConfirmedPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailConfirmedPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmationToken"] = this.confirmationToken;
        return data;
    }
}

export interface IEmailConfirmedPostModel {
    confirmationToken: string;
}

export class CreateEmailConfirmationTokenModel implements ICreateEmailConfirmationTokenModel {
    userId!: string;
    email!: string;

    constructor(data?: ICreateEmailConfirmationTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateEmailConfirmationTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmailConfirmationTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateEmailConfirmationTokenModel {
    userId: string;
    email: string;
}

export class BusinessEmailConfirmationStatusResponseModel implements IBusinessEmailConfirmationStatusResponseModel {
    isSubmitted!: boolean;
    isConfirmed!: boolean;

    constructor(data?: IBusinessEmailConfirmationStatusResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSubmitted = _data["isSubmitted"];
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): BusinessEmailConfirmationStatusResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessEmailConfirmationStatusResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSubmitted"] = this.isSubmitted;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }
}

export interface IBusinessEmailConfirmationStatusResponseModel {
    isSubmitted: boolean;
    isConfirmed: boolean;
}

export class FeedbackPostModel implements IFeedbackPostModel {
    source!: string;
    additionalData!: string;
    score!: number;
    comment!: string;
    user!: string;
    createdAtUtc!: Date;
    windowsSessionId?: string | undefined;

    constructor(data?: IFeedbackPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.additionalData = _data["additionalData"];
            this.score = _data["score"];
            this.comment = _data["comment"];
            this.user = _data["user"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
            this.windowsSessionId = _data["windowsSessionId"];
        }
    }

    static fromJS(data: any): FeedbackPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["additionalData"] = this.additionalData;
        data["score"] = this.score;
        data["comment"] = this.comment;
        data["user"] = this.user;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        data["windowsSessionId"] = this.windowsSessionId;
        return data;
    }
}

export interface IFeedbackPostModel {
    source: string;
    additionalData: string;
    score: number;
    comment: string;
    user: string;
    createdAtUtc: Date;
    windowsSessionId?: string | undefined;
}

export class FeedbackResponseModel implements IFeedbackResponseModel {
    id!: number;
    source!: string;
    additionalData!: string;
    score!: number;
    comment!: string;
    user?: UserSlimModel | undefined;
    unregisteredUsername?: string | undefined;
    createdAtUtc!: Date;

    constructor(data?: IFeedbackResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.source = _data["source"];
            this.additionalData = _data["additionalData"];
            this.score = _data["score"];
            this.comment = _data["comment"];
            this.user = _data["user"] ? UserSlimModel.fromJS(_data["user"]) : undefined as any;
            this.unregisteredUsername = _data["unregisteredUsername"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FeedbackResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbackResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["source"] = this.source;
        data["additionalData"] = this.additionalData;
        data["score"] = this.score;
        data["comment"] = this.comment;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["unregisteredUsername"] = this.unregisteredUsername;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IFeedbackResponseModel {
    id: number;
    source: string;
    additionalData: string;
    score: number;
    comment: string;
    user?: UserSlimModel | undefined;
    unregisteredUsername?: string | undefined;
    createdAtUtc: Date;
}

export class FeedbacksResultModel implements IFeedbacksResultModel {
    records!: FeedbackResponseModel[];
    totalRecords!: number;
    npsScore?: number | undefined;

    constructor(data?: IFeedbacksResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.records = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(FeedbackResponseModel.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
            this.npsScore = _data["npsScore"];
        }
    }

    static fromJS(data: any): FeedbacksResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new FeedbacksResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecords"] = this.totalRecords;
        data["npsScore"] = this.npsScore;
        return data;
    }
}

export interface IFeedbacksResultModel {
    records: FeedbackResponseModel[];
    totalRecords: number;
    npsScore?: number | undefined;
}

export enum UserType {
    Consumer = 0,
    University = 1,
    Company = 2,
    Consultant = 3,
}

export enum NpsCategory {
    Promoter = 0,
    Passive = 1,
    Detractor = 2,
}

export class DownloadScreenshotsResponseModel implements IDownloadScreenshotsResponseModel {
    requestId!: string;

    constructor(data?: IDownloadScreenshotsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): DownloadScreenshotsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScreenshotsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface IDownloadScreenshotsResponseModel {
    requestId: string;
}

export class DownloadScreenshotsRequestModel implements IDownloadScreenshotsRequestModel {
    screenshotIds!: number[];

    constructor(data?: IDownloadScreenshotsRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.screenshotIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["screenshotIds"])) {
                this.screenshotIds = [] as any;
                for (let item of _data["screenshotIds"])
                    this.screenshotIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DownloadScreenshotsRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadScreenshotsRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.screenshotIds)) {
            data["screenshotIds"] = [];
            for (let item of this.screenshotIds)
                data["screenshotIds"].push(item);
        }
        return data;
    }
}

export interface IDownloadScreenshotsRequestModel {
    screenshotIds: number[];
}

export class GenerateScreenshotsZipStatusResponse implements IGenerateScreenshotsZipStatusResponse {
    requestId!: string;
    status!: GenerateZipStatus;
    totalCount!: number;
    finishedCount!: number;
    errorMessage!: string;

    constructor(data?: IGenerateScreenshotsZipStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.status = _data["status"];
            this.totalCount = _data["totalCount"];
            this.finishedCount = _data["finishedCount"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): GenerateScreenshotsZipStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateScreenshotsZipStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["status"] = this.status;
        data["totalCount"] = this.totalCount;
        data["finishedCount"] = this.finishedCount;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IGenerateScreenshotsZipStatusResponse {
    requestId: string;
    status: GenerateZipStatus;
    totalCount: number;
    finishedCount: number;
    errorMessage: string;
}

export enum GenerateZipStatus {
    Pending = 0,
    InProgress = 1,
    Finished = 2,
    Failed = 3,
}

export class ScreenshotMessageResultModel implements IScreenshotMessageResultModel {
    screenshots!: ScreenshotMessageModel[];
    activeUsers!: ActiveUserResponseModel[];
    maxResponsesReached!: boolean;
    totalResults!: number;

    constructor(data?: IScreenshotMessageResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.screenshots = [];
            this.activeUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["screenshots"])) {
                this.screenshots = [] as any;
                for (let item of _data["screenshots"])
                    this.screenshots!.push(ScreenshotMessageModel.fromJS(item));
            }
            if (Array.isArray(_data["activeUsers"])) {
                this.activeUsers = [] as any;
                for (let item of _data["activeUsers"])
                    this.activeUsers!.push(ActiveUserResponseModel.fromJS(item));
            }
            this.maxResponsesReached = _data["maxResponsesReached"];
            this.totalResults = _data["totalResults"];
        }
    }

    static fromJS(data: any): ScreenshotMessageResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenshotMessageResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.screenshots)) {
            data["screenshots"] = [];
            for (let item of this.screenshots)
                data["screenshots"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.activeUsers)) {
            data["activeUsers"] = [];
            for (let item of this.activeUsers)
                data["activeUsers"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxResponsesReached"] = this.maxResponsesReached;
        data["totalResults"] = this.totalResults;
        return data;
    }
}

export interface IScreenshotMessageResultModel {
    screenshots: ScreenshotMessageModel[];
    activeUsers: ActiveUserResponseModel[];
    maxResponsesReached: boolean;
    totalResults: number;
}

export class ScreenshotMessageModel implements IScreenshotMessageModel {
    id!: string;
    computerName!: string;
    level!: number;
    username!: string;
    user?: UserSlimModel | undefined;
    screenshotFileName!: string;
    timestamp!: Date;
    action?: string | undefined;
    windowsSessionId?: string | undefined;

    constructor(data?: IScreenshotMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.computerName = _data["computerName"];
            this.level = _data["level"];
            this.username = _data["username"];
            this.user = _data["user"] ? UserSlimModel.fromJS(_data["user"]) : undefined as any;
            this.screenshotFileName = _data["screenshotFileName"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.action = _data["action"];
            this.windowsSessionId = _data["windowsSessionId"];
        }
    }

    static fromJS(data: any): ScreenshotMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenshotMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["computerName"] = this.computerName;
        data["level"] = this.level;
        data["username"] = this.username;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["screenshotFileName"] = this.screenshotFileName;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["action"] = this.action;
        data["windowsSessionId"] = this.windowsSessionId;
        return data;
    }
}

export interface IScreenshotMessageModel {
    id: string;
    computerName: string;
    level: number;
    username: string;
    user?: UserSlimModel | undefined;
    screenshotFileName: string;
    timestamp: Date;
    action?: string | undefined;
    windowsSessionId?: string | undefined;
}

export class ActiveUserResponseModel implements IActiveUserResponseModel {
    userId?: string | undefined;
    user?: UserSlimModel | undefined;

    constructor(data?: IActiveUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserSlimModel.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActiveUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IActiveUserResponseModel {
    userId?: string | undefined;
    user?: UserSlimModel | undefined;
}

export class ScreenshotsQuery implements IScreenshotsQuery {
    userId?: string | undefined;
    computerName?: string | undefined;
    username?: string | undefined;
    fromDate!: Date;
    toDate!: Date;
    take!: number;
    skip!: number;

    constructor(data?: IScreenshotsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.computerName = _data["computerName"];
            this.username = _data["username"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.take = _data["take"];
            this.skip = _data["skip"];
        }
    }

    static fromJS(data: any): ScreenshotsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ScreenshotsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["computerName"] = this.computerName;
        data["username"] = this.username;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["take"] = this.take;
        data["skip"] = this.skip;
        return data;
    }
}

export interface IScreenshotsQuery {
    userId?: string | undefined;
    computerName?: string | undefined;
    username?: string | undefined;
    fromDate: Date;
    toDate: Date;
    take: number;
    skip: number;
}

export class ReindexScreenshotsModel implements IReindexScreenshotsModel {
    screenshotId?: number | undefined;

    constructor(data?: IReindexScreenshotsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.screenshotId = _data["screenshotId"];
        }
    }

    static fromJS(data: any): ReindexScreenshotsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReindexScreenshotsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["screenshotId"] = this.screenshotId;
        return data;
    }
}

export interface IReindexScreenshotsModel {
    screenshotId?: number | undefined;
}

export class SessionListResultModel implements ISessionListResultModel {
    items!: SessionResponseModel[];
    totalRecords!: number;

    constructor(data?: ISessionListResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SessionResponseModel.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): SessionListResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SessionListResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface ISessionListResultModel {
    items: SessionResponseModel[];
    totalRecords: number;
}

export class SessionResponseModel implements ISessionResponseModel {
    id!: number;
    windowsSessionId?: string | undefined;
    windowsUsername!: string;
    userId?: string | undefined;
    user?: UserSlimModel | undefined;
    feedbackScore?: number | undefined;
    duration!: string;
    startedAtUtc!: Date;
    endedAtUtc!: Date;
    screenshotsCount!: number;
    dialogs!: DwsimProDialogType[];

    constructor(data?: ISessionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.dialogs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.windowsSessionId = _data["windowsSessionId"];
            this.windowsUsername = _data["windowsUsername"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserSlimModel.fromJS(_data["user"]) : undefined as any;
            this.feedbackScore = _data["feedbackScore"];
            this.duration = _data["duration"];
            this.startedAtUtc = _data["startedAtUtc"] ? new Date(_data["startedAtUtc"].toString()) : undefined as any;
            this.endedAtUtc = _data["endedAtUtc"] ? new Date(_data["endedAtUtc"].toString()) : undefined as any;
            this.screenshotsCount = _data["screenshotsCount"];
            if (Array.isArray(_data["dialogs"])) {
                this.dialogs = [] as any;
                for (let item of _data["dialogs"])
                    this.dialogs!.push(item);
            }
        }
    }

    static fromJS(data: any): SessionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SessionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["windowsSessionId"] = this.windowsSessionId;
        data["windowsUsername"] = this.windowsUsername;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["feedbackScore"] = this.feedbackScore;
        data["duration"] = this.duration;
        data["startedAtUtc"] = this.startedAtUtc ? this.startedAtUtc.toISOString() : undefined as any;
        data["endedAtUtc"] = this.endedAtUtc ? this.endedAtUtc.toISOString() : undefined as any;
        data["screenshotsCount"] = this.screenshotsCount;
        if (Array.isArray(this.dialogs)) {
            data["dialogs"] = [];
            for (let item of this.dialogs)
                data["dialogs"].push(item);
        }
        return data;
    }
}

export interface ISessionResponseModel {
    id: number;
    windowsSessionId?: string | undefined;
    windowsUsername: string;
    userId?: string | undefined;
    user?: UserSlimModel | undefined;
    feedbackScore?: number | undefined;
    duration: string;
    startedAtUtc: Date;
    endedAtUtc: Date;
    screenshotsCount: number;
    dialogs: DwsimProDialogType[];
}

export enum DwsimProDialogType {
    BusinessEmail_SubmitForm = 0,
    BusinessEmail_NotConfirmed = 1,
    RegistrationEmail_NotConfirmed = 2,
    Eula = 3,
    FeedbackForm = 4,
    Licensing_EnterCreditCard = 5,
    Licensing_EligibleForTrial = 6,
    Licensing_NoLicense = 7,
}

export class DialogShownPostModel implements IDialogShownPostModel {
    windowsSessionId!: string;
    dialog!: DwsimProDialogType;

    constructor(data?: IDialogShownPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.windowsSessionId = _data["windowsSessionId"];
            this.dialog = _data["dialog"];
        }
    }

    static fromJS(data: any): DialogShownPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new DialogShownPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["windowsSessionId"] = this.windowsSessionId;
        data["dialog"] = this.dialog;
        return data;
    }
}

export interface IDialogShownPostModel {
    windowsSessionId: string;
    dialog: DwsimProDialogType;
}

export class EulaAcceptedPostModel implements IEulaAcceptedPostModel {
    userId!: string;
    eulaType!: EulaType;
    acceptedAtUtc!: Date;

    constructor(data?: IEulaAcceptedPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.eulaType = _data["eulaType"];
            this.acceptedAtUtc = _data["acceptedAtUtc"] ? new Date(_data["acceptedAtUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EulaAcceptedPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new EulaAcceptedPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["eulaType"] = this.eulaType;
        data["acceptedAtUtc"] = this.acceptedAtUtc ? this.acceptedAtUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IEulaAcceptedPostModel {
    userId: string;
    eulaType: EulaType;
    acceptedAtUtc: Date;
}

export enum EulaType {
    Dashboard = 0,
    DwsimPro = 1,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}